(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds"]) return;
  try {
    

  /*
   * ============================================================
   * STIKRD UPDATE 2026-08-29 - PRODUCT HANDLE / DEBUG LOGGING
   * ============================================================
   * - Add ?debug=true to enable console debug output.
   * - All console.log calls route through debugLog().
   * - svgImageFile is derived from pn in the Design Studio shell.
   * - Legacy title/metafield/collective artwork-name mapping removed.
   * ============================================================
   */
  const debug =
    new URLSearchParams(window.location.search).get("debug") === "true";

  function debugLog() {
    if (debug) {
      console.log.apply(console, arguments);
    }
  }

  const SVG_VERSION = "20260908D";

  /*
   * ============================================================
   * STIKRD UPDATE 2026-08-29 - QUERY STRING IS SOURCE OF TRUTH
   * ============================================================
   * Product/session routing values are always read from the current
   * Design Studio URL. Product-page cookies are intentionally NOT used.
   *
   * Required/recognized parameters:
   *   pn       Shopify product handle / canonical artwork key
   *   pt       Product title
   *   vid      Variant ID to add back to the originating store cart
   *   store    Originating store identifier (blank = STIKRD)
   *   storeurl Originating store URL when returning to a partner cart
   *
   * This prevents stale product-page cookie values from affecting a
   * later Design Studio visit from STIKRD or a Collective partner.
   * ============================================================
   */
  var qs_pn = "";
  var qs_pt = "";
  var qs_vid = "";
  var qs_store = "";
  var qs_storeurl = "";
  var qs_cachebuster = SVG_VERSION;
  var hide_metallic_msg = false;

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");
    var sParameterName;
    var i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === "undefined"
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }

    return false;
  };

  // Read all product/session state from the current URL exactly once.
  qs_pn = getUrlParameter("pn") || "";
  qs_pt = getUrlParameter("pt") || "";
  qs_vid = getUrlParameter("vid") || "";
  qs_store = getUrlParameter("store") || "";
  qs_storeurl = getUrlParameter("storeurl") || "";
  qs_cachebuster = getUrlParameter("cachebuster") || SVG_VERSION;

  debugLog("QS pn:", qs_pn);
  debugLog("QS pt:", qs_pt);
  debugLog("QS vid:", qs_vid);
  debugLog("QS store:", qs_store);
  debugLog("QS storeurl:", qs_storeurl);
  debugLog("Generated SVG image:", svgImageFile);

  /*
   * The shell derives svgImageFile from pn. Keep the title synchronized
   * with pt, but never reconstruct the artwork filename from the title.
   */
  if (qs_pt.length > 0) {
    productTitle = qs_pt.replaceAll("+", " ").replaceAll("\"", "");
  }

  /*
   * Always use vid from the current URL for the cart form. There is no
   * cookie fallback and no partner variant-ID remapping in this path.
   */
  var vidElement = $('input[name="id"]');

  if (qs_vid.length > 0) {
    vidElement.val(qs_vid);
    debugLog("Set cart variant ID from QS vid:", qs_vid);
  } else {
    debugLog("No vid query-string parameter was supplied.");
  }

  // Direct STIKRD sessions post to the local cart. Partner cart routing
  // is handled later using the store/storeurl query-string parameters.
  if (qs_store.length <= 0) {
    $("#product-form").attr("action", "/cart/add");
  }


  debugLog("Shopify root:", window.Shopify.routes.root);

var nowStr = $.now();
  
const designId = "STIKRD-" + nowStr;
debugLog("secs: " + designId);
$("#design-id").val(designId);
  
var coll = document.getElementsByClassName("collapsible");
var i;
var colorPalette;
var Layer;
var onObject;
var colorPaletteName;
var masterColorHex = "";
var masterColorName = "";
var masterColorList = [];  
var masterColorNameList = [];  
var masterGradientColorList = [];  
var masterGradientColorNameList = [];  
var masterPatternColorList = [];  
var masterPatternColorNameList = [];  
var SVGimage;
var defaultColor = "typeButtonCherry";
var isSolid = true;
var isGloss = true;
var maxHeightColl = 264;
var welcomeText = "Select a Pantone or Brand color from the selections on the left.<br><br>Hover over the stickers to see highlighted sections and click to swap colors.";  
var defaultPatternSVG = "NATURE_PALMS_MIAMI.svg";
var patternLeftOffset = -325;
var patternTopOffset = -325;
var patternDefaultFactor = 2;
  
let zoomLevel = 1;
const zoomStep = 0.1;
const minZoom = 0.8;
const maxZoom = 3;

function collapseColors(obj) {
  debugLog("click, in collapseColors with: " + obj.id + ", TOGGLE it");
  obj.classList.toggle("active");
  var content = obj.nextElementSibling;
  if (content.style.maxHeight){
    content.style.maxHeight = null;
    debugLog("click 11: " + content.style.maxHeight);
  } else {
    if(maxHeightColl < content.scrollHeight)
      content.style.maxHeight = maxHeightColl + "px";
    else
      content.style.maxHeight = content.scrollHeight + "px";
    debugLog("click 22: " + content.style.maxHeight);
  } 
}

function collapseColorsBrand() {
  var brandColorDiv = $("#brand-colors-button");
  debugLog("click, ccBrand: " + brandColorDiv);
  collapseColors(brandColorDiv);
}
  
$('#pantone-colors-button').click(function (e) {
  debugLog("pan colors btn click" + e);
  collapseColors(this);
  var brandColorDivElem = document.getElementById("brand-colors-button");
  debugLog(brandColorDivElem);
  collapseColors(brandColorDivElem);
});
  
$('#brand-colors-button').click(function (e) {
  debugLog("brand colors btn click" + e);
  collapseColors(this);
  var pantoneColorDivElem = document.getElementById("pantone-colors-button");
  debugLog(pantoneColorDivElem);
  collapseColors(pantoneColorDivElem);
});
  
$('#patterns-button').click(function (e) {
  debugLog("patterns btn click" + e);
  this.classList.toggle("active");
  var content = this.nextElementSibling;
  if (content.style.maxHeight){
    debugLog("click pattern 1: " + content.style.maxHeight);
    content.style.maxHeight = null;
    debugLog("click pattern 1: " + content.style.maxHeight);
  } else {
    debugLog("click pattern 2: " + content.style.maxHeight);
    if(maxHeightColl < content.scrollHeight)
      content.style.maxHeight = maxHeightColl + "px";
    else
      content.style.maxHeight = content.scrollHeight + "px";
    debugLog("click pattern 2: " + content.style.maxHeight);
  } 
});
  
function setMainView(currentTab, isSolid) {
  debugLog("set main view: " + currentTab + ", " + isSolid);
  
  if (currentTab == 1) {
    $('#pattern2').hide();
    $('#gradient2').hide();
    $('#gradient2-outline').hide();
    $('#pattern2-outline').hide();
    $('#panel-2').hide();
    $('#panel-3').hide();  
    $('#panel-1').show();
    if (isSolid) {
      $('#home2').show();
      $('#home2-outline').hide();
    }
    else {
      $('#home2').hide();
      $('#home2-outline').show();
    }
  }
  if (currentTab == 2) {
    $('#pattern2').hide();
    $('#home2').hide();
    $('#home2-outline').hide();
    $('#pattern2-outline').hide();
    $('#panel-1').hide();
    $('#panel-3').hide();  
    $('#panel-2').show();
    if (isSolid) {
      $('#gradient2').show();
      $('#gradient2-outline').hide();
    }
    else {
      $('#gradient2').hide();
      $('#gradient2-outline').show();
    }
  }
  if (currentTab == 3) {
    $('#gradient2').hide();
    $('#home2').hide();
    $('#gradient2-outline').hide();
    $('#home2-outline').hide();
    $('#panel-2').hide();
    $('#panel-1').hide();  
    $('#panel-3').show();
    if (isSolid) { 
      $('#pattern2').show();
      $('#pattern2-outline').hide();
    }
    else {
      $('#pattern2').hide();
      $('#pattern2-outline').show();
    }
  }
}
  
function addColorButtonToSection(color, sectionId) {

  var tempKey = color[1];
  let key = tempKey.replaceAll(" ", "-");        
  let tempDiv = document.createElement("div");
  let value = color[2];
  //let percentage = color[4];

  tempDiv.setAttribute("id", "typeButton" + key);        
  tempDiv.setAttribute("style", "display: flex; cursor: pointer;");        

  document.getElementById(sectionId).appendChild(tempDiv); 
        
  let colorDiv = document.createElement("div");
  colorDiv.setAttribute("class", "swatch ds-center");
  colorDiv.setAttribute("id", key);
  colorDiv.setAttribute("data-color-hex", value.toLowerCase());
  colorDiv.setAttribute("style", "background-color: #" + value);

  let name = document.createElement("div");
  
  var percentMatch = color[4];
  var material = color[5];
  if(percentMatch == "")
    percentMatch = "100";
  let percentSpan = document.createElement("span");
  percentSpan.setAttribute("style", "font-size: 10px;"); // vertical-align: middle;
  percentSpan.innerText = " (" + percentMatch + "%)" + (material == "met" ? " M" : "");

  name.innerText = key.replaceAll("-", " ");
  name.setAttribute("id", "colorName-" +  key);
  name.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px;");
  name.appendChild(percentSpan);    
  
  tempDiv.appendChild(colorDiv);
  tempDiv.appendChild(name);
  
  tempDiv.addEventListener("click", () => {
      debugLog("color mousedown: " + key + ", val: " + value);
      colorPalette = "#" + value;	// saves color to be used when clicking on a group
      colorPaletteName = tempKey;     
      debugLog("tempkey: " + tempKey);

      // clear all actives first then set active
      //$('[id^="colorName"]').css("margin", "4px 4px");
      $('[id^="colorName"]').css("font-weight", "normal");    
    
      // set selected border or indicate selected
      var colorActive = document.getElementById("colorName-" +  key);
      colorActive.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px; font-weight: bold");
                      
      updateColors(key, value);

      // alert
      if (material == "met" && !hide_metallic_msg) {
        $('#material-modal').modal('show');
      }
  }, false);
}   
  
var pathStr = "../cdn/shop/files/";
var imageName = "";
  
function createPatternButtons() {

  var htmlPattern = "";
  var key = "key";
  var value = "val";
  debugLog("create patterns...");
      
  for(var i = 0; i < patternInfo.length; i++) {
    var pattern = patternInfo[i];

    if(pattern[1].indexOf(".svg") < 0)
      continue;
    debugLog("pattern info: " + i + ", name:" + pattern[0] + ", image: " + pattern[1] + ", idx: " + pattern[1].indexOf("USAFlag"));
    htmlPattern = htmlPattern + "<div style='display: flex' data-pidx='" + i + "' id='patternImage" + i + "'><div id='pid" + i + "' class='swatch swatch-pattern'><img class='pattern-img' src='" + pathStr + pattern[1] + "' ></div><div class='mt-3 ml-1' id='patternName" + i + "'>" + pattern[0] + "</div></div>";    
  }
  $("#patternHolderMain").append(htmlPattern); 
  
  // patternImage click handlers
  $('[id^="patternImage"]').each(function (index, element) {
    let pidx = element.dataset.pidx;
    element.addEventListener("click", () => {
 
      $("#stikrd-pattern-range").val(1);
      $("#stikrd-pattern-rotate").val(0);
      $("#pattern-stretch-value").text("1");
      $("#pattern-rotate-value").text("0");

      // clear color arrays
      masterPatternColorList = [];
      masterPatternColorNameList = [];
      
      var pattern = patternInfo[pidx];
      debugLog("Pattern mousedown: " + pattern[0]);
      var value = pattern[1];
      var key = pattern[0];
        
      // clear all actives first then set active
      $('[id^="patternName"]').css("font-weight", "normal");    

      // set selected border or indicate selected
      var patternActive = $("#patternName" + index);
      debugLog("pattern mousedown!!!: " + patternActive.attr("id"));
      patternActive.attr("style", "font-weight: bold");

      updatePattern(key, value);

      // apply pattern on click
      fillPattern(canvasPattern, isSolid);
      fillPattern(canvasPatternOutline, isSolid);      
    }, false);
  }); 
}
  
// return active tab number
function getActiveTab() {
  // nav-link
  // home, gradient, pattern
  if ($("#home-tab").hasClass("active")) {
    debugLog("2home active: " + $("#home-tab.active"));
    return 1;
  }
  else if ($("#gradient-tab").hasClass("active")) {
    debugLog("2grad active: " + $("#gradient-tab.active"));
    return 2;
    
  }
  else if($("#pattern-tab").hasClass("active")){
    debugLog("3pattern active: " + $("#pattern-tab.active"));
    return 3; 
  }
}  

function getActiveCanvas() {
  debugLog("get active canvas...");
  
  // find active canvas and return it
  let activeTab = getActiveTab();
  
  if (activeTab == 1) {
    if (isSolid) {
  debugLog("get active canvas1 solid...");
      return canvas;
    }
    else {
  debugLog("get active canvas1 outline...");
      return canvasOutline;
    }
  } 
  else if (activeTab == 2) {
    if(isSolid)
      return canvasGradient;  
    else
      return canvasGradientOutline;
  }
  else if (activeTab == 3) {
    if(isSolid)
      return canvasPattern;
    else
      return canvasPatternOutline;
  }
}  

function resetZoom() {
  debugLog("zoom reset");
  let canvas = getActiveCanvas();
  zoomLevel = 1;
  canvas.setZoom(zoomLevel);
  canvas.setViewportTransform([zoomLevel, 0, 0, zoomLevel, 0, 0]);
}
  
// #pantone
function createColorButtons() {
  
    for(var i = 0; i < colorInfo.length; i++) {
      var color = colorInfo[i];
      
      if (color[0] == "PANTONE") {

        if (debug && 1 == 0) {
          for(var j = 0; j < color.length; j++) {
            debugLog("color[" + i + "] = " + color[j]);
            debugLog("color[" + i + "] = " + color[1]);
          }        
        }
        addColorButtonToSection(color, "pantoneHolderMain");      
      }
    }

    // build color brands ---------------------------
    var currentBrand = "";
    var htmlColors = "";
    var firstColor = true;
  
    for(var i = 0; i < colorInfo.length; i++) {
      var color = colorInfo[i];
      var colorGroup = color[0];
      
      // group by name not PANTONE
      if (colorGroup != "PANTONE") {
            if (currentBrand != colorGroup) {
              currentBrand = colorGroup;

              if(!firstColor)
                htmlColors = htmlColors + "</ul></li>";         
                
              htmlColors = htmlColors + "<ul id='stikrdUL'><li><span class='caret'>" + currentBrand + "</span><ul class='nested nested-content nested-brand'>";  
              firstColor = false;
            }
            var tempKey = color[1];
            var percentMatch = color[4];
            var material = color[5];
            if(percentMatch == "")
              percentMatch = "100";
        
            let key = tempKey.replaceAll(" ", "-");        
            let value = color[2];
          
            htmlColors = htmlColors + "<li class='nothingcache3'><div style='display: flex; cursor: pointer;' data-mat='" + material + "' data-hex='" + value + "' id='typeButtonBrand" + key + "'>";
        
            htmlColors = htmlColors + "<div class='swatch ds-center' style='background-color: #" + value + "' id='" + key.replaceAll(" ", "-") + "'></div>";
            htmlColors = htmlColors + "<div style='font-size: 12px; margin: 7px 4px 0px 3px;' id='colorName-" + key + "'>" + key.replaceAll("-", " ") + " <span style='font-size: 10px'>(" + percentMatch + "%)" + (material == "met" ? " M" : "") + "</span></div> ";        
            htmlColors = htmlColors + "</div></li>";        
      }
    }
  
    // close UL
    htmlColors = htmlColors + "</li></ul><br>&nbsp;<br>";  
    $("#brandHolderMain").append(htmlColors); 

    // typeButtonBrand click handlers
    $('[id^="typeButtonBrand"]').each(function (index, element) {
      element.addEventListener("click", () => {
      
          debugLog("color BRAND mousedown: " + $(this).children().first().attr("id"));
          var value = $(this).data("hex");
          var material = $(this).data("mat");
          var key = $(this).children().first().attr("id");
          var tempKey = key.replaceAll("-", " ");
        
          debugLog("color mousedown: " + key);
          colorPalette = "#" + value;	//saves color to be used when clicking on a group
          colorPaletteName = tempKey;     
    
          // clear all actives first then set active
          $('[id^="colorName"]').css("margin", "7px 4px 0px 3px");
          $('[id^="colorName"]').css("font-weight", "normal");    
        
          // set selected border or indicate selected
          var colorActive = document.getElementById("colorName-" +  key);
          colorActive.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px; font-weight: bold");
                          
          updateColors(key, value);

          // alert
          if (material == "met" && !hide_metallic_msg) {
            $('#material-modal').modal('show');
          }
      }, false);
    }); 

    $("#reset-btn").on( "click", function() {
      debugLog("reset: tab: , solid? " + isSolid + ", actvie tab:" + getActiveTab());
      if (getActiveTab() == 1) {
        let usedColors = $("#used-colors");
        //usedColors.html(welcomeText);
        
        //clear color array
        masterColorList = [];
        masterColorNameList = [];
        
        usedColorsList.length = 0;
        canvas.clear();
        // call setup
        initColorSwap();

        canvasOutline.clear();
        // call setup
        initColorSwapOutline();
      }
      
      if (getActiveTab() == 2) {
        $("#gradient-checkbox-3").prop("checked", false);
        $("#gradient-checkbox-4").prop("checked", false);
        $("#gradient-color-1").css("background-color","#FFFFFF");
        $("#gradient-color-1").data("hex-color", "#FFFFFF");
        $("#gradient-color-1").data("name-color", "White");
        $("#gradient-color-2").css("background-color","#888B8D");
        $("#gradient-color-2").data("hex-color", "#888B8D");
        $("#gradient-color-2").data("name-color", "Black");
        $("#stikrd-range").val(50);
        $("#gradient-directions").val(1);
        $("#gradient-strength-value").html("50");
        
          canvasGradient.clear();
          // call setup
          initGradient();
          canvasGradientOutline.clear();
          // call setup
          initGradientOutline();           
      }

      if (getActiveTab() == 3) {
        debugLog("reset pattern!");
        
        //clear color array
        masterPatternColorList = [];
        masterPatternColorNameList = [];
        
        // function to reset pattern
        $("#stikrd-pattern-range").val(1);
        $("#stikrd-pattern-rotate").val(0);
        $("#pattern-stretch-value").text("1");
        $("#pattern-rotate-value").text("0");
        
        //updatePattern(patternInfo[0][0], patternInfo[0][1]);
        debugLog("click the first pattern: " + $('#pid0').length);
        $('#pid0').first().click();         
      }
    });
  
    $("#gradient-btn").on( "click", function() {
      if(isSolid)
        fillGradient(canvasGradient, isSolid);
      else
        fillGradient(canvasGradientOutline, isSolid);
      debugLog("gradient and outline btn click, solid? " + isSolid);
    });
    
    $("#pattern-btn").on( "click", function() {
      if(isSolid)
        fillPattern(canvasPattern, isSolid);
      else
        fillPattern(canvasPatternOutline, isSolid);
      debugLog("pattern and outline btn click, solid? " + isSolid);
    });
  
    $("#solidOutlineSwitch").on( "click", function() {
      isSolid = !isSolid;
      debugLog("switch solid-outline btn click: solid> " + isSolid);
          setMainView(activeTab, isSolid);
    });

    $("#finishSwitch").on( "click", function() {
      isGloss = !isGloss;
      debugLog("switch finish btn click: solid> " + isGloss);
    });
  
    $("#gradient-color-1").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      debugLog("grad color 11 update to: " + colorPalette);
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
    });

    $("#gradient-color-2").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      debugLog("grad color 2 update to: " + colorPalette);
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
    });
  
    $("#gradient-color-3").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      $("#gradient-checkbox-3").prop('checked', true);
      debugLog("grad color 3 update to: " + colorPalette);
      
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      debugLog("gradient color 3, solid? " + isSolid);
    });

    $("#gradient-checkbox-3").on( "click", function() {
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      debugLog("gradient checkbox color 3, solid? " + isSolid + this.checked);
    });
                              
    $("#gradient-color-4").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      $("#gradient-checkbox-4").prop('checked', true);
      debugLog("grad color 4 update to: " + colorPalette);

      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      debugLog("gradient color 4, solid? " + isSolid);
    });

    $("#gradient-checkbox-4").on( "click", function() {
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      debugLog("gradient checkbox color 4, solid? " + isSolid + this.checked);
    });
  
    $("#gradient-directions").on( "change", function() {
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      debugLog("gradient directions listbox dropdown, solid? " + isSolid);
    });
  
    $(".pattern-swatch-color").on( "click", function() {
      alert('color');
      debugLog("pattern swatch color");
    });
}

function updateAllObjectColors(canvas, newColor, newColorName) {
    
    debugLog("updateAllObjectColors: color: " + newColor + ", canvs id: " + canvas.id);
    debugLog("ct objs: ", canvas.getObjects());

    canvas.getObjects().forEach(function (obj) {
        debugLog("updateAllObjectColors: obj.id: " + obj.id);
        if (obj.id != null && obj.id.toLowerCase().startsWith("layer")) {
          debugLog("fill? : " + obj.type + ", id: "+ obj.id + ", fill: " + obj.fill + ", name: " + obj.colorName);    
          if (obj.set) {
              obj.fire('mousedown', {
                  e: null,               // optional: native mouse event
                  target: obj
              });
          } 
        }
    });

    canvas.requestRenderAll();
}
  
function getObjectsFromCanvas(canvas) {
  debugLog("getObjectsFromCanvas...");
  var objects = [];
  canvas.getObjects().forEach(function (obj) {
    if (obj != null && obj.type == "path" && ((obj.id.startsWith("LAYER_") && isSolid) || (obj.id.startsWith("TOP_") && !isSolid))) {
      debugLog("get obj from canvas LAYER and TOP: " + obj.id + ", type: " + obj.type);
      objects.push(obj);
    }
  });
  return objects;                              
} 
 
function getObjectById(canvas, objId) {
  var activeObject = null;
  canvas.getObjects().forEach(function (obj) {
      if (obj.id === objId) {    
        activeObject = obj;
        debugLog("get object: activeObj found!" + obj.id);
      }
  })
  return activeObject;
}

var originalScaleX = 1;
var originalScaleY = 1;
var patterObjects = null;
var patterOutlineObjects = null;
  
function swapPatternColor(currentColor) {
  
  debugLog("swapPatternColor: currentColor: " + currentColor + ", colorPalette: " + colorPalette);
  
  // SWAP COLORS USED also

  canvasPattern.getObjects().forEach(function (obj) {  

    debugLog("swapPatternColor: " + obj.id + ", fill:" + obj.fill + ", type: " + obj.type + ", currentColor: " + currentColor);
    if (obj.type == "group") {
      obj._objects.forEach(function(object) {
        debugLog("object: " + object.id + ", fill: " + object.fill);
        if (object.id != undefined && object.id.toLowerCase().startsWith("layer") && currentColor == object.fill) {
          debugLog("FOUND!");      
          object.set('fill', colorPalette);
          swapMasterPatternColorsUsed(currentColor);
        }
      });
    }               
    canvasPattern.requestRenderAll();
  });

  canvasPatternOutline.getObjects().forEach(function (obj) {
    
    debugLog("swapPatternColor: " + obj.id + ", fill:" + obj.fill + ", type: " + obj.type + ", currentColor: " + currentColor);
    if (obj.type == "group") {
      obj._objects.forEach(function(object) {
        debugLog("object: " + object.id + ", fill: " + object.fill);
        if (currentColor == object.fill && object.id.toLowerCase().startsWith("layer")) {
          debugLog("FOUND!");      
          object.set('fill', colorPalette);
          //TODO2
        }
      });
    }               
    canvasPatternOutline.requestRenderAll();
  });
} 

function showPatternColors(layers) {

  patternColorsList = [];
  
  let patternColors = $("#pattern-colors");
  var fillColor = "";
  $('.pattern-colors-list').remove();
  
  layers.forEach(function (obj) {
    debugLog("layer:" + obj.id);
    let tempDiv = document.createElement("div");
    tempDiv.setAttribute("class", "swatch ds-center pattern-colors-list");        
    tempDiv.setAttribute("data-hex", obj.fill);        
    tempDiv.setAttribute("style", "margin: -4px 5px 0px 0px; background-color: " + obj.fill);        

    fillColor = obj.fill;
    
    // check duplicates
    if (patternColorsList.indexOf(fillColor) < 0) {
      patternColorsList.push(fillColor);   
      patternColors.append(tempDiv);      
      updateMasterPatternColorsUsed(fillColor, "");
    }
  
    // #click-color-pattern
    tempDiv.addEventListener("click", function() {
        debugLog("color mousedown: " + this.getAttribute("data-hex")); //.attr("data-hex").val());
      swapPatternColor(this.getAttribute("data-hex"));
      // change the color of the clicked box; update data-hex and background-color
      $(this).attr("data-hex", colorPalette);
      $(this).css("background-color", colorPalette);   
    });
  });       
}  
  
function showPatternColorsOLD(layers) {

  patternColorsList = [];
  layers.forEach(function (obj) {
    
    debugLog("PATTERN: " + obj.type + ", id: "+ obj.id + ", fill: " + obj.fill); 
    // build the list of colors       
    var tempStr = '<div class="swatch ds-center pattern-swatch-color" data-hex="' + obj.fill + '" style="background-color:' + obj.fill + '"></div>';
    // check duplicates
    if(patternColorsList.indexOf(tempStr) < 0)
      patternColorsList.push(tempStr);   
  });  
  
  let patternColors = $("#pattern-colors");
  var patternColorsHeaderDiv = '<div><div style="font-weight: bold">Pattern Colors:</div><div style="margin-bottom: 5px; margin-top: -10px"><span style="font-size: 10px">(click color to swap with active)</span></div></div>';     
  var patternColorsDiv = "";
  
  patternColorsList.forEach(function (obj) {
    debugLog("patternColorsList!");
    patternColorsDiv = patternColorsDiv + obj;  
  });

  patternColors.css("font-style", "normal"); 
  patternColors.html(patternColorsHeaderDiv + '<div style="display: flex; flex-wrap: wrap;">' + patternColorsDiv + '</div>'); 
}
 
function setPattern(image, canvas) {
  
  debugLog("setPattern!!!!!!!!!!: path: " + pathStr + ", image: " + image);

  var activeObject = null;

  // remove current pattern
  activeObject = getObjectById(canvas, "canvas-pattern-image");
  if (activeObject != null) {                             
    debugLog("setPattern: set source, xxxx:" + activeObject.width + ", " + activeObject.height);
    debugLog("setPattern: set source, xxxx:" + activeObject.scaleX + ", " + activeObject.scaleY);
    debugLog("setPattern: set source, xxxx222:" + activeObject.id + "-" + activeObject.scaleX + ", " + activeObject.scaleY);  
    canvas.remove(activeObject);
    canvas.renderAll();      
  }
  else {
    debugLog("No active object, do not delete it.");    
  }
  
  // load desired pattern 
  fabric.loadSVGFromURL(pathStr + image, function (objects, options) {
    
      var img = fabric.util.groupSVGElements(objects, options); 

      showPatternColors(objects);

      debugLog("path: " + pathStr + "-" + image);
      debugLog("SVG PATTERN: width: " + img.width + ", height: " + img.height);
      if (img.width > canvas.getWidth()) {
          //img.scaleToWidth(canvas.getWidth());
          debugLog("SVG PATTERN2: width: " + img.width + ", height: " + img.height);
      }
      if (img.height > canvas.getHeight()) {
          //img.scaleToHeight(canvas.getHeight());
          debugLog("SVG PATTERN3: width: " + img.width + ", height: " + img.height);
      }
    
      debugLog("SVG PATTERN: width: " + img.width + ", height: " + img.height);
      var x = canvasPattern.width / img.width;
      var y = canvasPattern.height / img.height;
      var factor = 1; // TODO REVERT? patternDefaultFactor;

      var largest = x;
      if(y > x)
        largest = y;
    
      debugLog("SVG PATTERN x, y: x: " + x + ", y: " + y + ", factor: " + factor);
    
      img.scaleX = largest * factor;
      img.scaleY = largest * factor;
      debugLog("OFFSET: left: " + img.left + ", top: " + img.top);
    
      originalScaleX = largest * factor;
      originalScaleY = largest * factor;

      img.set({
        borderColor: 'red',
        cornerColor: 'black',
        cornerStrokeColor: 'red',
        transparentCorners: false,
        cornerSize: 16
      });    

      img.id = "canvas-pattern-image";
      canvas.add(img);
      canvas.sendToBack(img);
      canvas.renderAll();    
    
      debugLog("PATTERN SETUP: height: " + img.height + ", width: " + img.width + ", canvas w:" + canvasPattern.width);
  });
  canvas.renderAll();      
}
  
function makeTransparent(paths) {

  var toggle = 0;
  
  paths.forEach(function (obj) {
    if (obj != null) {
      debugLog("make transparent Id: " + obj.id);
                    
      if (obj.fill != "" && toggle > 0) {
          obj.set({ opacity: 0 });
      }
      toggle = toggle > 0 ? 0 : 1; 
    }
  });
  canvas.renderAll();      

}
  
function updateColors(key, color) {
    debugLog("update colors: key: " + key + ", color: " + color);
  
    let name = $("#colorDisplayText");

    // clear all actives first then set active
    $('[id^="colorName"]').css("font-weight", "normal");    

    // set selected border or indicate selected
    key = key.replaceAll(" ", "-");
    var colorActive = document.getElementById("colorName-" +  key);
    colorActive.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px; font-weight: bold");
  
    key = key.replaceAll("-", " ");
  
    var strDiv = '<div id="typeButtonActiveColorMain" style="display: flex; cursor: pointer;"><div class="swatch ds-center" style="background-color: #' + color + '"></div><div style="font-size: 12px; margin: 5px 4px; font-weight: normal">' + key + '</div></div>';  
    colorPalette = "#" + color;	//saves color to be used when clicking on a group
    colorPaletteName = key;    
  
    name.html(strDiv);
}
  
function updatePattern(key, pattern) {
    let name = $("#patternDisplayText");
    imageName = pattern;
    var strDiv = '<div id="typeButtonPattern" style="display: flex; cursor: pointer;"><div class="swatch swatch-pattern ds-center" style=""><img id="active-pattern-img" class="pattern-img" src="' + pathStr + pattern + '"></div><div style="font-weight: normal; font-size: 12px; margin-top: 5px">' + key + '</div></div>';  
    name.html(strDiv);
}
 
function fillGradient(canvasToFill, isSolid) {  
  var color1 = $("#gradient-color-1").css("background-color");
  var color2 = $("#gradient-color-2").css("background-color");
  var color3 = $("#gradient-color-3").css("background-color");
  var color4 = $("#gradient-color-4").css("background-color");
  var color1hex = $("#gradient-color-1").data("hex-color");
  var color2hex = $("#gradient-color-2").data("hex-color");
  var color3hex = $("#gradient-color-3").data("hex-color");
  var color4hex = $("#gradient-color-4").data("hex-color");
  var color1name = $("#gradient-color-1").data("name-color");
  var color2name = $("#gradient-color-2").data("name-color");
  var color3name = $("#gradient-color-3").data("name-color");
  var color4name = $("#gradient-color-4").data("name-color");
  var coordinates = ""; // top down, 8 options
  // stikrd-range
  var range = $("#stikrd-range").val();
  // gradient-directions
  var direction = $("#gradient-directions").val();
  var colorStops = [
          { offset: 0, color: color1 },
          { offset: 1, color: color2 } ];
        
  debugLog("range: " + range + ", direction: " + direction);
  // 100 ideal but want 50
  range = range * 2;
  if (range > 0) {
    range = range / 100;
  }
  
  //clear color array
  masterGradientColorList = [];
  masterGradientColorNameList = [];

  debugLog("range: " + range + ", direction: " + direction);
  debugLog("color1-hex: " + color1hex + ", color1name: " + color1name);
  debugLog("color2-hex: " + color2hex + ", color2name: " + color2name);
  debugLog("color3-hex: " + color3hex + ", color3name: " + color3name);
  debugLog("color4-hex: " + color4hex + ", color4name: " + color4name);
  
  // optional colors
  debugLog("checkbox3: " + $("#gradient-checkbox-3").is(':checked'));
  debugLog("checkbox4: " + $("#gradient-checkbox-4").is(':checked'));
  updateMasterGradientColorsUsed(color1hex, color1name);
  updateMasterGradientColorsUsed(color2hex, color2name);
  if ($("#gradient-checkbox-3").is(':checked') && $("#gradient-checkbox-4").is(':checked')) {
      debugLog("checkbox3 AND 4");
      colorStops = [
            { offset: 0, color: color1 },
            { offset: .33, color: color2 }, 
            { offset: .66, color: color3 }, 
            { offset: 1, color: color4 } 
      ];    
      updateMasterGradientColorsUsed(color3hex, color3name);
      updateMasterGradientColorsUsed(color4hex, color4name);
  }
  else {
    if ($("#gradient-checkbox-3").is(':checked')) {
      debugLog("checkbox3: " + $("#gradient-checkbox-3").is(':checked'));
      colorStops = [
            { offset: 0, color: color1 },
            { offset: .5, color: color2 }, 
            { offset: 1, color: color3 } 
      ];    
      updateMasterGradientColorsUsed(color3hex, color3name);
    }
    if ($("#gradient-checkbox-4").is(':checked')) {
      debugLog("checkbox4: " + $("#gradient-checkbox-4").is(':checked'));
      colorStops = [
            { offset: 0, color: color1 },
            { offset: .5, color: color2 }, 
            { offset: 1, color: color4 } 
      ];    
      updateMasterGradientColorsUsed(color4hex, color4name);
    }
  }  
  
  canvasToFill.getObjects().forEach(function (obj) {
    debugLog("canvasToFill.getObjects().forEach: ID=" + obj.id);

    if (obj?.id) {
      const id = obj.id.toLowerCase();

      if (
        (obj.type === "path" && id.startsWith("layer_")) ||
        (id.startsWith("outline") && !isSolid)
      ) {
    

//      if((obj != null && obj.type == "path" && (obj.id.toLowerCase().startsWith("layer_") ) ) 
//        || ((obj != null && ((obj.id.toLowerCase().startsWith("outline") && !isSolid)) ))) {
      
        debugLog("COMBO fill grad LAYER and TOP 4444: " + obj.id + ", type: " + obj.type + ", color1: " + color1 + ", color2:" + color2 + ", color3: " + color3 + ", color4:" + color4);

        if(direction == 1)
          // top down
          coordinates = { x1: 0, y1: 0, x2: 0, y2: range };
        if(direction == 2)
          // bottom up
          coordinates = { x1: 0, y1: range, x2: 0, y2: 0 };
        if(direction == 3)
          // left to right
          coordinates = { x1: 0, y1: 0, x2: range, y2: 0 };
        if(direction == 4)
          // right to left
          coordinates = { x1: range, y1: 0, x2: 0, y2: 0 };
        if(direction == 5)
          // top right
          coordinates = { x1: 0, y1: 0, x2: range, y2: range };
        if(direction == 6)
          // top left
          coordinates = { x1: range, y1: 0, x2: 0, y2: range };
        if(direction == 7)
          // bottom left
          coordinates = { x1: 0, y1: range, x2: range, y2: 0 };
        if(direction == 8)
          // bottom right
          coordinates = { x1: range, y1: range, x2: 0, y2: 0 };
        var gradient = new fabric.Gradient({
          type: 'linear',
          gradientUnits: 'percentage', // or 'percentage'
          coords: coordinates,
          colorStops: colorStops
        })
        obj.set({ fill: gradient });        
      }
      else if (obj != null && obj.type == "path" && ((obj.id.toLowerCase().startsWith("outline") && !isSolid)) ) {
        debugLog("OUTLINE fill grad LAYER and TOP 6666: " + obj.id + ", type: " + obj.type);
      }
      else
        debugLog("NO fill grad LAYER and TOP 7777: " + obj.id + ", type: " + obj.type + ", color1: " + color1 + ", color2:" + color2 + ", color3: " + color3 + ", color4:" + color4);
    }
  });
      
  canvasToFill.renderAll();      
}
  
function fillPattern(canvasToFill, isSolid) { 
  
  debugLog("fill pattern" + isSolid);

  setPattern(imageName, canvasToFill);
  
  canvasToFill.renderAll();      
}
  
$('#dpid').text(productTitle.toUpperCase());
$('#dpid-footer').text(productTitle.toUpperCase());
$('#dpiddebug').text(getUrlParameter('pid') + ' and Title: ' + getUrlParameter('pn') + '.');
fabric.Object.prototype.objectCaching = false;

// create a wrapper around native canvas element
var canvas = new fabric.Canvas('canvas', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas'
});

/*
 * STIKRD UPDATE 2026-08-29
 * Attach the #3 tooltip to Fabric's stable canvas wrapper instead
 * of the canvas element itself. Fabric changes the canvas positioning
 * during initialization, which can cause Bootstrap/Popper to calculate
 * an incorrect tooltip position.
 */
var canvasTooltipTarget =
  canvas.wrapperEl ||
  document.getElementById("canvas").closest(".canvas-container");

var newTooltip_canvas =
  bootstrap.Tooltip.getOrCreateInstance(canvasTooltipTarget, {
    placement: "left",
    title: "#3 Hover over the sticker to highlight sections to Color Swap.",
    container: "body",
    trigger: "manual"
  });

var canvasGradient = new fabric.Canvas('canvas-gradient', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-gradient'
});
var canvasPattern = new fabric.Canvas('canvas-pattern', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-pattern'
});
var canvasOutline = new fabric.Canvas('canvas-outline', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-outline'
});
var canvasGradientOutline = new fabric.Canvas('canvas-gradient-outline', {
    preserveObjectStacking: true,
    selection: false,    
    id: 'canvas-gradient-outline'
});
var canvasPatternOutline = new fabric.Canvas('canvas-pattern-outline', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-pattern-outline'
});

const zoomMap = new Map();
zoomMap.set(canvas, zoomLevel);
zoomMap.set(canvasOutline, zoomLevel);
zoomMap.set(canvasGradient, zoomLevel);
zoomMap.set(canvasGradientOutline, zoomLevel);
zoomMap.set(canvasPattern, zoomLevel);
zoomMap.set(canvasPatternOutline, zoomLevel);
  
const SVG_PATH = "../cdn/shop/"; 
  
// STIKRD UPDATE: svgImageFile is derived client-side from the current pn handle.
var site_url_path = SVG_PATH + svgImageFile + "?v=" + qs_cachebuster;
debugLog("svgImageFile : " + site_url_path);
    
var site_url = site_url_path; //imgElement.src;
var site_url_outline =  site_url_path.replace("_SOLID.svg", "_OUTLINE.svg");
    
var site_url_gradient =  site_url_path.replace("_SOLID.svg", "_SOLID_GRADIENT.svg");
var site_url_gradient_outline =  site_url_path.replace("_SOLID.svg", "_OUTLINE_GRADIENT.svg");

var site_url_pattern =  site_url_path.replace("_SOLID.svg", "_SOLID_PATTERN.svg");
var site_url_pattern_outline =  site_url_path.replace("_SOLID.svg", "_OUTLINE_PATTERN.svg");
var init = true;  
debugLog("site_ur: " + site_url + ", outline: " + site_url_outline + ", new: " + site_url_pattern);
  
var previousColor = "";
var hoverColor = "#CCFF00";
var activeTab = 1;
var usedColorsList = [];
var patternColorsList = [];
var productBoundingWidth = 725;
var productBoundingHeight = 725;
  
// scale actual svg onto this canvas
function scaleSvg(canvas, objSVG) {
  var scaleFactor = 0;
  var juice = 2;
  
  debugLog("bound w: " + productBoundingWidth + ", bound h: " + productBoundingHeight);
  debugLog("width: " + objSVG.width + ", height: " + objSVG.height);
  
  // only scale to the width
  scaleFactor = (productBoundingWidth) / (objSVG.width - juice);
  
  debugLog("scale factor ZZ22: " + scaleFactor);
  objSVG.scale(scaleFactor);
  
  if (objSVG.height * scaleFactor > productBoundingHeight) {
    debugLog("y gt x: " + canvas.getWidth() + ", height--u  : " + objSVG.height);
    canvas.setDimensions({ width: canvas.getWidth(), height: objSVG.height * scaleFactor });
  }
}  
  
// scale actual svg onto this canvas
function scaleSvgObjects(canvas, objSVG, objects) {
  var scaleFactor = 0;

  debugLog("bound w: " + productBoundingWidth + ", bound h: " + productBoundingHeight);
  debugLog("width: " + objSVG.width + ", height: " + objSVG.height);

  // only scale to the width
  scaleFactor = (productBoundingWidth) / objSVG.width;
    
  debugLog("scale factor: " + scaleFactor);

  objects.forEach(function (obj) {
    debugLog("for each obj!: " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top);    
    obj.scale(scaleFactor);
  });
  
  if (objSVG.height * scaleFactor > productBoundingHeight) {
    debugLog("y gt x: " + canvas.getWidth() + ", height--u  : " + objSVG.height);
    canvas.setDimensions({ width: canvas.getWidth(), height: objSVG.height * scaleFactor });
  }
}  

function updateMasterColorsFromLayers(canvas) {
    var colorList = [];
    masterColorList = [];
    masterColorNameList = [];
    canvas.getObjects().forEach(function (obj) {
      if (obj.id != null && obj.id.toLowerCase().startsWith("layer")) { 
        debugLog("fill? : " + obj.type + ", id: "+ obj.id + ", fill: " + obj.fill + ", name: " + obj.colorName);    
        if (colorList.indexOf(obj.fill) < 0) {
          colorList.push(obj.fill);
          masterColorList.push(obj.fill);
          if(obj.colorName != undefined && obj.colorName != null)
            masterColorNameList.push(obj.colorName);
          else
            masterColorNameList.push("Default");
            
        }
      }
    });
    return colorList;
}  

function createMasterColorListHtml(masterColorList, masterColorNameList) {
    var i = 0;
    var usedColorsHtml = "";
    masterColorList.forEach(function (obj) {
      debugLog("hex: " + obj + ", i:" + i + ", name lookup: " + masterColorNameList[i]);
      var template = '<div style="display: flex"><div class="swatch ds-center" style="background-color:' + obj + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + masterColorNameList[i] + '</div></div>';

      usedColorsHtml = usedColorsHtml + template; 
      i++;
    });  
    return usedColorsHtml;
} 
  
function createMasterColorNameList(masterColorNameList) {
    var separator = "";
    var usedColors = "";
  
    masterColorNameList.forEach(function (obj) {
      debugLog("create name: " + obj);
      if(separator.length > 0)
        usedColors = usedColors + ", ";  
      usedColors = usedColors + obj;  
      separator = "true";
    });
    return usedColors;
}

function updateCustomColors(canvas) {
  var usedColors = "";
  var usedColorsHtml = "";
  var layerColorList = [];
  
  debugLog("KOLORS: updateCustomColors: ");
  
  let activeTab = getActiveTab();
  if (activeTab == 1) {  
  
    // integrity check, user may have used color but then overwrote it with another
    layerColorList = updateMasterColorsFromLayers(canvas);
    
    debugLog("color list : " + layerColorList);    

    usedColorsHtml = createMasterColorListHtml(masterColorList, masterColorNameList);
    usedColors = createMasterColorNameList(masterColorNameList);
  }  
  if (activeTab == 2) {  
    masterGradientColorList.forEach(function (obj) {
      debugLog("gradient hex: " + obj);
    });
    usedColorsHtml = createMasterColorListHtml(masterGradientColorList, masterGradientColorNameList);    
    
    masterGradientColorNameList.forEach(function (obj) {
      debugLog("gradient name: " + obj);
    });
    usedColors = createMasterColorNameList(masterGradientColorNameList);
    debugLog("used colors: " + usedColors);
    
  }
  else if (activeTab == 3) {  
    masterPatternColorList.forEach(function (obj) {
      debugLog("hex: " + obj);
    });
    usedColorsHtml = createMasterColorListHtml(masterPatternColorList, masterPatternColorNameList);    
    
      debugLog("mcnl0: " + masterPatternColorNameList.length);
    for(i = 0; i < masterPatternColorNameList.length; i++) {
      debugLog("mcnl: i: " + i + ", " + masterPatternColorNameList[i]);
    }
 
    masterPatternColorNameList.forEach(function (obj) {
      debugLog("debug name: " + obj);
    });
    usedColors = createMasterColorNameList(masterPatternColorNameList);
    debugLog("used colors: " + usedColors);
  }

  $("#custom-colors").val(usedColors);
  $("#custom-colors-html").val(usedColorsHtml);
}
  
function addLegend(canvas) {
  debugLog("Add legend..." + canvas + ", mainH: "+ mainHeight + ", canvasH: " + canvas.height + ", mainW: " + mainWidth + ", canvasW: " + canvas.width);

  var topLegend = mainHeight / 2; //canvas.height;
  var left = mainWidth / 2 * -1;
  var topInner = 20;
  var offset = -125;
  var leftInner = offset;

  debugLog("top: " + topLegend + ", left: " + left + ", topInner: " + topInner + ", leftInner: " + leftInner);
  
  // find corresponding legend object and add 
  var activeObject = getObjectById(canvas, "legend");
  if (activeObject != null) {
    debugLog("legend exists: " + activeObject.id);
    canvas.remove(activeObject);
    canvas.renderAll();
  }

  var circle = null;
  var pantone = null;
  var text = new fabric.Text(designId, {
    fontSize: 24
  });
  
  var group = new fabric.Group([ text ], {
    id: "legend",
    left: left,
    top: topLegend
  });
  
  let activeTab = getActiveTab();
  if (activeTab == 1) {  

  // integrity check, user may have used color but then overwrote it with another
    
    masterColorList.forEach(function (obj) {
      debugLog("hex: " + obj);
      circle = new fabric.Circle({
        radius: 20, fill: obj, left: leftInner, top: topInner
      });
      group.add(circle);
      leftInner = leftInner + 50;
    });
    
    topInner = topInner + 25;
    masterColorNameList.forEach(function (obj) {
      debugLog("name: " + obj);
      topInner = topInner + 20;
      pantone = new fabric.Text(obj, {
        fontSize: 16,
        left: offset,
        top: topInner
      });
      group.add(pantone);
    });
  }  
  if (activeTab == 2) {  
    masterGradientColorList.forEach(function (obj) {
      debugLog("hex: " + obj);
      circle = new fabric.Circle({
        radius: 20, fill: obj, left: leftInner, top: topInner
      });
      group.add(circle);
      leftInner = leftInner + 50;
    });
    
    topInner = topInner + 25;
    masterGradientColorNameList.forEach(function (obj) {
      debugLog("name: " + obj);
      topInner = topInner + 20;
      pantone = new fabric.Text(obj, {
        fontSize: 16,
        left: offset,
        top: topInner
      });
      group.add(pantone);
    });
  }
  else if (activeTab == 3) {  
    masterPatternColorList.forEach(function (obj) {
      debugLog("hex: " + obj);
      circle = new fabric.Circle({
        radius: 20, fill: obj, left: leftInner, top: topInner
      });
      group.add(circle);
      leftInner = leftInner + 50;
    });
    
    topInner = topInner + 25;
    masterPatternColorNameList.forEach(function (obj) {
      debugLog("name: " + obj);
      topInner = topInner + 20;
      pantone = new fabric.Text(obj, {
        fontSize: 16,
        left: offset,
        top: topInner
      });
      group.add(pantone);
    });
  }
  canvas.add(group); 
  canvas.renderAll();
}
  
function updateMasterColorsUsed(hex, name) {
  debugLog("KOLORS: updateMasterColorsUsed: Add to list: hex: " + hex + ", name: " + name);
  
  // check duplicates
  if (masterColorList.indexOf(hex) < 0) {
    masterColorList.push(hex);
    masterColorNameList.push(name);
  } 
}
  
function updateMasterGradientColorsUsed(hex, name) {
  debugLog("mgrad hex: " + hex + ", mgrad name: " + name);
  
  // check duplicates
  if (masterGradientColorList.indexOf(hex) < 0) {
    masterGradientColorList.push(hex);
    masterGradientColorNameList.push(name);
  } 
}

function updateMasterPatternColorsUsed(hex, name) {
  debugLog("hex: " + hex + ", update name: " + name);
  
  // check duplicates
  if (masterPatternColorList.indexOf(hex) < 0) {
    masterPatternColorList.push(hex);
    if(name == null || name == "")
      masterPatternColorNameList.push("Default");
    else
      masterPatternColorNameList.push(name);
  } 
}

function swapMasterPatternColorsUsed(currentColor) {
  
  debugLog("currentColor: " + currentColor);
  
  // check duplicates
  if (masterPatternColorList.indexOf(currentColor) >= 0) {
    for (var i = 0; i < masterPatternColorList.length; i ++) {
        if (masterPatternColorList[i] == currentColor) { 
            debugLog("pop: " + currentColor);
            masterPatternColorList.splice(i, 1);
            masterPatternColorNameList.splice(i, 1);
            // pop name????
            break;
        }
    }    
    debugLog("push: " + colorPalette);
    masterPatternColorList.push(colorPalette);
    masterPatternColorNameList.push(colorPaletteName);
  }   
} 

function isPixelOpaque(obj, pointer) {
  // create a temporary offscreen canvas
  const tempCanvas = fabric.util.createCanvasElement();
  tempCanvas.width = obj.width * obj.scaleX;
  tempCanvas.height = obj.height * obj.scaleY;
  const ctx = tempCanvas.getContext('2d');

  // render the object onto it
  const tempObj = fabric.util.object.clone(obj);
  tempObj.left = 0;
  tempObj.top = 0;
  tempObj.render(ctx);

  // convert pointer to local object coordinates
  const local = obj.toLocalPoint(new fabric.Point(pointer.x, pointer.y), 'center', 'center');

  const px = Math.round(local.x + tempCanvas.width / 2);
  const py = Math.round(local.y + tempCanvas.height / 2);

  if (px < 0 || py < 0 || px >= tempCanvas.width || py >= tempCanvas.height) {
    return false;
  }

  const pixel = ctx.getImageData(px, py, 1, 1).data;
  return pixel[3] > 0; // alpha channel > 0 = opaque
}

var mainWidth = 350;  
var mainHeight = 350;  
var textNotAvailable = new fabric.Text('This sticker is not\navailable at this time.', { left: 100, top: 100, textAlign: 'center' });
  
// canvas main home solid #1 
function initColorSwap() {  
  fabric.loadSVGFromURL(site_url, function (objects, options) {

  debugLog("#1 " + site_url);
    if (null != objects) {
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      if (objSVG != null) {
        mainWidth = objSVG.width;
        mainHeight = objSVG.height;
        //debugLog("objSVG width: " + objSVG.width); // + ", " + objSVG.objects.length); 
      }
      
      objects.forEach(function (obj) {
          
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })
    
        if (obj.id.toLowerCase().startsWith("layer")) { 
  
          // mouse over
          obj.on("mouseover", function(){
            if (this.fill != "") {
              previousColor = this.fill;
              this.set({ fill: hoverColor });
            }        
            canvas.renderAll();
          });
        
          // mouse out
          obj.on("mouseout", function(){
            if (this.fill != "") {
              if(this.fill == hoverColor)
                this.set({ fill: previousColor });
            }        
            canvas.renderAll();
          });
    
          // fill with active color
          obj.on("mousedown", function(){ 
              if (this.fill != "") {
                this.set({ fill: colorPalette });
                this.colorName = colorPaletteName;
              }

              // find corresponding outline object and update
              activeObject = getObjectById(canvasOutline, obj.id);
              if (activeObject != null) {
                //debugLog("GETIT7: " + activeObject.id);
                activeObject.set({ fill: colorPalette });
                activeObject.colorName = colorPaletteName;
                canvasOutline.renderAll();
              }
            
              canvas.renderAll();
              let usedColors = $("#used-colors");
              var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
              var usedColorsDiv = '<div class="stikrd">Colors Used:</div>';
              // check duplicates
              if(usedColorsList.indexOf(tempStr) < 0)
                usedColorsList.push(tempStr);
             
              usedColorsList.forEach(function (obj) {
                usedColorsDiv = usedColorsDiv + obj;  
              });
            
              usedColors.css("font-style", "normal"); 
              usedColors.html(usedColorsDiv); 

              updateMasterColorsUsed(colorPalette, colorPaletteName);
          });
        }       
        canvas.add(obj); //.renderAll();
        
      });  
  
      scaleSvg(canvas, objSVG);
    }
    else {
      canvas.add(textNotAvailable).renderAll;    
    }

    canvas.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvas.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvas.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvas.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvas.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvas.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvas.on('mouse:up', function(opt) {
      isDragging = false;
      canvas.selection = true;
    });
    
  });
}
  
// canvas main home outline #2
function initColorSwapOutline() {
  fabric.loadSVGFromURL(site_url_outline, function (objects, options) {
    if (null != objects) {
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      objects.forEach(function (obj) {
                                       
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })
        
        if (obj.id.toLowerCase().startsWith("layer")) {         
          
          // mouse over
          obj.on("mouseover", function(){
            //debugLog("mouseover outline 111");
            if (this.fill != "") {
              previousColor = this.fill;
              this.set({ fill: hoverColor });
            }        
            canvasOutline.renderAll();
          });
        
          // mouse out
          obj.on("mouseout", function(){
            if (this.fill != "") {
              if(this.fill == hoverColor)
                this.set({ fill: previousColor });
            }        
            canvasOutline.renderAll();
          });
    
          // fill with active color
          obj.on("mousedown", function(){ 
              if (this.fill != "") {
                this.set({ fill: colorPalette });
                this.colorName = colorPaletteName;
              }
            
              // find corresponding outline object and update
              activeObject = getObjectById(canvas, obj.id);
              if (activeObject != null) {
                //debugLog("GETIT#22: " + activeObject.id);
                activeObject.set({ fill: colorPalette });
                activeObject.colorName = colorPaletteName;
                canvas.renderAll();
              }
    
              let usedColors = $("#used-colors");
              var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
              var usedColorsDiv = '<div style="font-weight: bold">Colors Used:</div>';
              // check duplicates
              if(usedColorsList.indexOf(tempStr) < 0)
                usedColorsList.push(tempStr);
             
              usedColorsList.forEach(function (obj) {
                usedColorsDiv = usedColorsDiv + obj;  
              });
              usedColors.css("font-style", "normal"); 
              usedColors.html(usedColorsDiv); 
            
              updateMasterColorsUsed(colorPalette, colorPaletteName);
            
              canvasOutline.renderAll();
          });    
        }
        else if (obj.id.toLowerCase() == "background") {                               
          // canvasOutline.add(obj).renderAll;
          //debugLog("background check");
        }
        canvasOutline.add(obj); //.renderAll;
        
      });  
  
      scaleSvg(canvasOutline, objSVG);
    }
    else {
      canvasOutline.add(textNotAvailable).renderAll;    
    }
    
    canvasOutline.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasOutline.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvasOutline.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvasOutline.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasOutline.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasOutline.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasOutline.on('mouse:up', function(opt) {
      isDragging = false;
      canvasOutline.selection = true;
    });

  });
}
  
// canvas gradient #3
function initGradient() {
  fabric.loadSVGFromURL(site_url_gradient, function (objects, options) {
    if (null != objects) {

        // Iterate over each object in the SVG
        debugLog('#3 SVG loaded successfully! Total objects: ' + objects.length);
        debugLog('-----------------------------------');
        objects.forEach((obj, index) => {
            debugLog(`Object ${index + 1}:`);
            debugLog(`  Type: ${obj.type}`); // e.g., 'circle', 'rect', 'path', 'group', 'i-text'
            debugLog(`  Left: ${obj.left}`);
            debugLog(`  Top: ${obj.top}`);
            obj.originalLeft = obj.left;
            obj.originalTop = obj.top;
            debugLog(`  Width: ${obj.width}`);
            debugLog(`  Height: ${obj.height}`);
            debugLog(`  Fill Color: ${obj.fill}`);
            // Check for common properties like ID
            if (obj.id) {
                 debugLog(`  ID: ${obj.id}`);
            }
            // Check for specific text properties if it's a text object
            if (obj.type === 'i-text' || obj.type === 'text') {
                debugLog(`  Text Content: ${obj.text}`);
            }
            debugLog('-----------------------------------');
        });
            
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      objects.forEach(function (obj) {
            
        debugLog("objSVG: #3 foreach set lock etc"); 
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })

const fillColor = obj.fill ? new fabric.Color(obj.fill).toHex().toLowerCase() : "";
const objIdType = obj.id ? obj.id.toLowerCase() : "";

      debugLog("#3 Check for colorable sections: fill color: " + fillColor + ", ID: " + objIdType + ", stikrd_pid_q: " + stikrd_pid_q + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);
if (
  objIdType.startsWith("background") &&
  (fillColor === "ffffff" || fillColor === "000000") &&
  obj.originalLeft < -0.9 &&
  obj.originalTop < -0.9 && stikrd_pid_q === "9660916138205"
) {
  
          debugLog("MATCH BACKGROUND: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);
}

if (
  (obj.id.toLowerCase().startsWith("overlay") &&
  (fillColor === "ffffff" || fillColor === "000000") &&
  obj.originalLeft > 0.5 &&
  obj.originalTop > 0.5) || (objIdType.startsWith("background") &&
  (fillColor === "ffffff" || fillColor === "000000") &&
  obj.originalLeft < -0.9 &&
  obj.originalTop < -0.9 && stikrd_pid_q === "9660916138205")
) {
  
          debugLog("MATCH: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);

  //if (obj.id.toLowerCase().startsWith("overlay") && (obj.fill.toLowerCase() == "#ffffff" || obj.fill.toLowerCase() == "#000000") && (obj.originalLeft > 0.5 && obj.originalTop > 0.5)) {         
          // mouse over
          obj.on("mouseover", function(){
            if (this.fill != "") {
              previousColor = this.fill;
              this.set({ fill: hoverColor });
            }        
            canvasGradient.renderAll();
          });
        
          // mouse out
          obj.on("mouseout", function(){
            if (this.fill != "") {
              if(this.fill == hoverColor)
                this.set({ fill: previousColor });
            }        
            canvasGradient.renderAll();
          });
          
          // fill with active color
          obj.on("mousedown", function(){ 
              if (this.fill != "") {
                this.set({ fill: colorPalette });
                this.colorName = colorPaletteName;
              }
                
              let usedColors = $("#used-colors");
              var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
              var usedColorsDiv = '<div style="font-weight: bold">Colors Used:</div>';
              // check duplicates
              if(usedColorsList.indexOf(tempStr) < 0)
                usedColorsList.push(tempStr);
             
              usedColorsList.forEach(function (obj) {
                usedColorsDiv = usedColorsDiv + obj;  
              });
              usedColors.css("font-style", "normal"); 
              usedColors.html(usedColorsDiv); 
            
              updateMasterColorsUsed(colorPalette, colorPaletteName);
            
              canvasGradient.renderAll();
          });   
        
        }
        //else {
        //  debugLog("No match: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);
        //}
        
        canvasGradient.add(obj).renderAll;    
      });  
      
      // fill with a gradient with the default color
      fillGradient(canvasGradient, true);
      
      scaleSvg(canvasGradient, objSVG);
    }
    else {
      canvasGradient.add(textNotAvailable).renderAll;    
    }
    
    canvasGradient.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasGradient.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvasGradient.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvasGradient.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasGradient.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasGradient.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasGradient.on('mouse:up', function(opt) {
      isDragging = false;
      canvasGradient.selection = true;
    });

  });
}
 
// canvas gradient outline #4
function initGradientOutline() {
  fabric.loadSVGFromURL(site_url_gradient_outline, function (objects, options) {

    if (null != objects) {
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      objects.forEach(function (obj) {
            
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })
        
        canvasGradientOutline.add(obj).renderAll;    
      });  
      
      // fill the gradient outline with the default color
      fillGradient(canvasGradientOutline, false);
        
      scaleSvg(canvasGradientOutline, objSVG);
    }
    else {
      canvasGradientOutline.add(textNotAvailable).renderAll;    
    }
    canvasGradientOutline.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasGradientOutline.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvasGradientOutline.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvasGradientOutline.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasGradientOutline.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasGradientOutline.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasGradientOutline.on('mouse:up', function(opt) {
      isDragging = false;
      canvasGradientOutline.selection = true;
    });    
  });
}

// canvas pattern #5
function initPattern() {  

  // load the main custom image
  fabric.loadSVGFromURL(site_url_pattern, function (objects, options) {
    if (null != objects) {

       // Iterate over each object in the SVG
      debugLog('#5 SVG loaded #5 successfully! Total objects: ' + objects.length);
      debugLog('-----------------------------------');
     objects.forEach((obj, index) => {
          obj.originalLeft = obj.left;
          obj.originalTop = obj.top;
          // Check for specific text properties if it's a text object
          if (obj.type === 'i-text' || obj.type === 'text') {
              debugLog(`  Text Content: ${obj.text}`);
          }
          //debugLog('-----------------------------------');
      }); 
      
      var objSVG = fabric.util.groupSVGElements(objects, options);
      
      objects.forEach(function (obj) {
        
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        });

        if (obj.id.toLowerCase().startsWith("overlay") && (obj.fill.toLowerCase() == "#ffffff" || obj.fill.toLowerCase() == "#000000") && (obj.originalLeft > 0 && obj.originalTop > 0)) {         
          
            // mouse over
            obj.on("mouseover", function(){
              if (this.fill != "") {
                previousColor = this.fill;
                this.set({ fill: hoverColor });
              }        
              canvasPattern.renderAll();
            });
          
            // mouse out
            obj.on("mouseout", function(){
              if (this.fill != "") {
                if(this.fill == hoverColor)
                  this.set({ fill: previousColor });
              }        
              canvasPattern.renderAll();
            });
            
            // fill with active color
            obj.on("mousedown", function(){ 
                if (this.fill != "") {
                  this.set({ fill: colorPalette });
                  this.colorName = colorPaletteName;
                }
              
                // find corresponding solid object and update
                activeObject = getObjectById(canvasPatternOutline, obj.id);
                if (activeObject != null) {
                  //debugLog("GETIT#55: " + activeObject.id);
                  activeObject.set({ fill: colorPalette });
                  activeObject.colorName = colorPaletteName;
                  canvasPatternOutline.renderAll();
                }
      
                let usedColors = $("#used-colors");
                var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
                var usedColorsDiv = '<div style="font-weight: bold">Colors Used:</div>';
                // check duplicates
                if(usedColorsList.indexOf(tempStr) < 0)
                  usedColorsList.push(tempStr);
               
                usedColorsList.forEach(function (obj) {
                  usedColorsDiv = usedColorsDiv + obj;  
                });
                usedColors.css("font-style", "normal"); 
                usedColors.html(usedColorsDiv); 
              
                updateMasterColorsUsed(colorPalette, colorPaletteName);
              
                canvasPattern.renderAll();
            });  
        }
        else {
          debugLog("No match: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);
        }
        //canvasPattern.targetFindTolerance = 0;
        
        canvasPattern.add(obj).renderAll;    
      });
  
      scaleSvg(canvasPattern, objSVG);
    }
    else {
      canvasPattern.add(textNotAvailable).renderAll;    
    }
    
    canvasPattern.renderAll(); 

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasPattern.on('mouse:down', function(opt) {

      const target = opt.target;
      if (target) {
        const pointer = canvas.getPointer(opt.e);
        if(target.type == "group" || target.type == "image") //isPixelOpaque(target, pointer)) 
          debugLog("clicked on a visible (non-transparent) pixel of GROUP/IMAGE:", target.type);        
        else {
          debugLog("✅ Clicked on a visible (non-transparent) pixel of:", target.type);

          const evt = opt.e;
          isDragging = true;
          canvasPattern.selection = false;
          lastPosX = evt.clientX;
          lastPosY = evt.clientY;

        }
      } else {
        debugLog("❌ Clicked on a transparent part (no hit detected).");
      }

    });

    canvasPattern.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasPattern.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasPattern.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasPattern.on('mouse:up', function(opt) {
      isDragging = false;
      canvasPattern.selection = true;
    });

  });
}
 
// canvas pattern outline #6
function initPatternOutline() {  

  fabric.loadSVGFromURL(site_url_pattern_outline, function (objects, options) {
    if (null != objects) {

       // Iterate over each object in the SVG
      debugLog('#6 SVG loaded #6 successfully! Total objects: ' + objects.length);
      //debugLog('-----------------------------------');
       objects.forEach((obj, index) => {
          obj.originalLeft = obj.left;
          obj.originalTop = obj.top;
          // Check for common properties like ID
          // Check for specific text properties if it's a text object
          if (obj.type === 'i-text' || obj.type === 'text') {
              debugLog(`  Text Content: ${obj.text}`);
          }
          //debugLog('-----------------------------------');
      }); 



      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      objects.forEach(function (obj) {

        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        });
          
        canvasPatternOutline.add(obj).renderAll;    
      });

      scaleSvg(canvasPatternOutline, objSVG);
    }
    else {
      canvasPatternOutline.add(textNotAvailable).renderAll;    
    }
    
    canvasPatternOutline.renderAll();  
    
    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasPatternOutline.on('mouse:down', function(opt) {
      const target = opt.target;
      if (target) {
        if(target.type == "group" || target.type == "image")
          debugLog("clicked on a visible (non-transparent) pixel of GROUP/IMAGE:", target.type);        
        else {
          debugLog("✅ Clicked on a visible (non-transparent) pixel of:", target.type);

          const evt = opt.e;
          isDragging = true;
          canvasPattern.selection = false;
          lastPosX = evt.clientX;
          lastPosY = evt.clientY;

        }
      } else {
        debugLog("❌ Clicked on a transparent part (no hit detected).");
      }
    });

    canvasPatternOutline.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasPatternOutline.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasPatternOutline.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasPatternOutline.on('mouse:up', function(opt) {
      isDragging = false;
      canvasPatternOutline.selection = true;
    });    
    
  }); 
}

function setCartVariantId() {
  var qs_vid = getUrlParameter("vid") || "";
  var vidElement = $('input[name="id"]');

  if (qs_vid.length <= 0) {
    console.error("STIKRD Design Studio: missing vid query parameter.");
    return false;
  }

  if (vidElement.length <= 0) {
    console.error("STIKRD Design Studio: cart variant input not found.");
    return false;
  }

  vidElement.val(qs_vid);

  debugLog("Cart variant ID set from QS vid:", qs_vid);

  return true;
}

// call each panel and setup  
initColorSwap();  
initColorSwapOutline();
initGradient();  
initGradientOutline();
initPattern();  
initPatternOutline();

$('#myTab a').click(function (e) {
  e.preventDefault();
  $(this).show();
})

$('#myTab button').click(function (e) {
  e.preventDefault();
  $(this).show();
})
  
$('#home-tab').click(function (e) {
  debugLog("home click....");
  activeTab = 1;
  e.preventDefault();
  setMainView(activeTab, isSolid);
  $("#pattern-container").hide(); 
  $("#btn-help-1").show();
  $("#btn-help-2").hide();
  $("#btn-help-3").hide();
});

$('#gradient-tab').click(function (e) {
  debugLog("gradient click");
  activeTab = 2;
  e.preventDefault();
  setMainView(activeTab, isSolid);
  $("#pattern-container").hide();  
  $("#btn-help-2").show();
  $("#btn-help-1").hide();
  $("#btn-help-3").hide();
});

$('#pattern-tab').click(function (e) {
  debugLog("pattern click");
  activeTab = 3;
  e.preventDefault();
  setMainView(activeTab, isSolid);
  // show patterns
  $("#pattern-container").show();

  $("#btn-help-3").show();
  $("#btn-help-1").hide();
  $("#btn-help-2").hide();
});

// #addtocart
$('#btn-add-to-cart').click(function (e) {
  debugLog("add to cart handler...");  
  $('#modal-acknowledgement').modal('show');
  return false;
});
$('#btn-add-to-cart-sticky').click(function (e) {
  debugLog("add to cart handler...");  
  $('#modal-acknowledgement').modal('show');
  return false;
});

var waitForMe = true;
  
setTimeout(postProcessFunc, 4000);  
  
function postProcessFunc() {
  $('[class^="_BarWrapper_"]').hide();
  waitForMe = false;
  $(".overlay").hide();
  debugLog("post process events typeButton regualr click : " + ", ID: " + $('[id^="typeButton"]').first().attr("id") + ", -ct: " + $('[id^="typeButton"]').length + ", " + $('[id^="typeButton"]').first().length);

}

// slider gradient setup
var slider = document.getElementById("stikrd-range");
var output = document.getElementById("gradient-strength-value");
output.innerHTML = slider.value;

slider.oninput = function() {
  output.innerHTML = this.value;

  fillGradient(canvasGradient, isSolid);
  fillGradient(canvasGradientOutline, isSolid);
  debugLog("gradient slider move, solid? " + isSolid);
}

// slider pattern setup
var sliderPattern = document.getElementById("stikrd-pattern-range");
var outputPattern = document.getElementById("pattern-stretch-value");
outputPattern.innerHTML = sliderPattern.value;

// stretch pattern  
sliderPattern.oninput = function() {
  outputPattern.innerHTML = this.value;
  debugLog("slide stretch..." + this.value);
  var factor = 1;
  var activeObj = null;
  var activeObjOutline = null;

  // SOLID -----------------------------------------------------------
  activeObject = getObjectById(canvasPattern, "canvas-pattern-image");
  if (activeObject == null) {
    debugLog("could not find active pattern object...");
  }
  else {
    // expand / shrink image based on slider
    factor = (1 + (this.value * .01));
    debugLog("slide2...factor:" + factor + ", origScaleX: " + originalScaleX + ", origScaleY: " + originalScaleY + ", activeScaleX: " + activeObject.scaleX + ", actScaleY: " + activeObject.scaleY + ", num:" + this.value);
    
    debugLog("left: " + activeObject.left + ", top: " + activeObject.top);
    
    var scaleX = originalScaleX; //activeObject.scaleX;
    var scaleY = originalScaleY; //activeObject.scaleY;
    var left = 0; 
    var top = 0; 

    var tempScaleX = scaleX * factor;
    var tempScaleY = scaleY * factor;
    var tempLeft = (625 * factor) - 625;
    var tempTop = (625 * factor) - 625;

    activeObject.scaleX = tempScaleX;
    activeObject.scaleY = tempScaleY;
    
    activeObject.left = tempLeft * -1;
    activeObject.top = tempTop * -1;
    
    activeObject.setCoords();
    activeObject.set("dirty", true);
 
    debugLog("dirty Val: " + this.value + ", patternLeftOffset: " + patternLeftOffset + ", patternTopOffset: " + patternTopOffset + ", new left: " + tempLeft + ", new top: " + tempTop);
    debugLog("slide2..." + activeObject.scaleX + ", " + activeObject.scaleY + ", " + this.value);
    
    canvasPattern.renderAll();    
  }
  
  canvasPattern.renderAll();
  
  // OUTLINE SLIDER ------------------------------------------------
  activeObjOutline = getObjectById(canvasPatternOutline, "canvas-pattern-image");
  if (activeObjOutline == null) {
    debugLog("could not find active pattern object...");
  }
  else {   
    debugLog("slide2...origScaleX: " + originalScaleX + ", origScaleY: " + originalScaleY + ", activeScaleX: " + activeObjOutline.scaleX + ", actScaleY: " + activeObjOutline.scaleY + ", " + this.value);

    factor = (1 + (this.value * .01));
    var scaleX = originalScaleX; //activeObjOutline.scaleX;
    var scaleY = originalScaleY; //activeObjOutline.scaleY;
    var left = 0; //patternLeftOffset * -1; 
    var top = 0; //patternTopOffset * -1; 

    var tempScaleX = scaleX * factor;
    var tempScaleY = scaleY * factor;
    var tempLeft = (625 * factor) - 625;
    var tempTop = (625 * factor) - 625;

    activeObjOutline.scaleX = tempScaleX;
    activeObjOutline.scaleY = tempScaleY;
    activeObjOutline.left = tempLeft * -1;
    activeObjOutline.top = tempTop * -1;

    activeObjOutline.setCoords();
    activeObjOutline.set("dirty", true);

    debugLog("Val: " + this.value + ", patternLeftOffset: " + patternLeftOffset + ", patternTopOffset: " + patternTopOffset + ", new:" + (patternLeftOffset - (this.value * 5)));
    debugLog("slide2..." + activeObjOutline.scaleX + ", " + activeObjOutline.scaleY + ", " + this.value);
    canvasPatternOutline.renderAll();

  }
  canvasPatternOutline.renderAll();
}

// rotate pattern setup
var rotatePattern = document.getElementById("stikrd-pattern-rotate");
var outputRotatePattern = document.getElementById("pattern-rotate-value");
outputRotatePattern.innerHTML = rotatePattern.value;

rotatePattern.oninput = function() {
  outputRotatePattern.innerHTML = this.value;
  debugLog("rotate..." + this.value);

  var activeObj = null;
  var activeObjOutline = null;
  
  activeObject = getObjectById(canvasPattern, "canvas-pattern-image");
  if (activeObject == null) {
    debugLog("could not find active pattern object...");
  }
  else {
    // expand / shrink image based on slider
    debugLog("rotatezoom..." + activeObject.id + ", " + this.value);
    activeObject.rotate(this.value);    
    activeObject.setCoords();
    canvasPattern.renderAll();
  }

  // OUTLINE ROTATE
  activeObjOutline = getObjectById(canvasPatternOutline, "canvas-pattern-image");
  if (activeObjOutline == null) {
    debugLog("could not find active pattern OUTLINE object...");
  }
  else {
    // expand / shrink image based on slider
    debugLog("rotatezoom..." + activeObjOutline.id + ", " + this.value);
    activeObjOutline.rotate(this.value);
    activeObjOutline.setCoords();
    canvasPatternOutline.renderAll();
  }
}

let usedColors = $("#used-colors");
//usedColors.html(welcomeText);

let bdfg = "69!";

// handle used color clicks, add to active color    
const usedColorsWrapper = document.querySelector(".used-colors-container");
usedColorsWrapper.addEventListener("click", (event) => {
  const div = event.target;

  debugLog("used color click set active: " + div.id + ", " + div.getAttribute("data-hex"));
  
  updateColors(div.id.replaceAll("-", " "), div.getAttribute("data-hex").replace("#", ""));
});  
  
$('#help-modal').on('show.bs.modal', function (event) {
  var modal = $(this)
  debugLog("modal email");
})
  
// #send message for help
$('#help-send-message').click(function (e) {
  debugLog("send help message");
  // find active canvas and save svg
  let activeTab = getActiveTab();
  let svg = null;
  if (activeTab == 1) {
    if (isSolid) {
      // save 1    
      try {   
        sendEmailHelp(canvas, true); 
      }
      catch(err) {
        debugLog(err.message);
      };      
    }  
    else {
      // save 2
      try {   
        sendEmailHelp(canvasOutline, true); 
      }
      catch(err) {
        debugLog(err.message);
      };
    }
  } 
  else if (activeTab == 2) {
    if (isSolid) {
      // save 1
      try {   
        sendEmailHelp(canvasGradient, true); 
      }
      catch(err) {
        debugLog(err.message);
      };
    }  
    else {
      // save 2
      try {   
        sendEmailHelp(canvasGradientOutline, true); 
      }
      catch(err) {
        debugLog(err.message);
      };
    }
  }
  else if (activeTab == 3) {
    if (isSolid) {
      // save 1
      try {   
        sendEmailHelp(canvasPattern, true); 
      }
      catch(err) {
        debugLog(err.message);
      };
    }  
    else {
      // save 2
      try {   
        sendEmailHelp(canvasPatternOutline, true); 
      }
      catch(err) {
        debugLog(err.message);
      };
    }
  }
});
  
// #button for help
$('#btn-help').click(function (e) {
    debugLog("help modal popup message");
    $('#modal-help').modal('show');
});
  
// #button for help 
$('#btn-help-1').click(function (e) {
    $('#modal-help-1').modal('show');
});
// #button for help
$('#btn-help-2').click(function (e) {
    $('#modal-help-2').modal('show');
});
// #button for help
$('#btn-help-3').click(function (e) {
    $('#modal-help-3').modal('show');
});
 
// send design
function sendEmailHelp(canvas, adjust) {
  debugLog("send email test extra prep help:");

  AWS_S3_Generate_Upload.prepHelp(canvas, adjust);
}
  
// send design #sendEmail
function sendEmail(canvas, adjust) {

  $(".overlay").show();

  resetZoom();

  var origWidth = canvas.width;
  var origHeight = canvas.height;
  
  // add a color bar with pantones
  addLegend(canvas);

   canvas.getObjects().forEach(function (obj) {
if (obj.hasOwnProperty('originalTop')) {
  debugLog("original top: " + obj.originalTop);
}     
if (obj.hasOwnProperty('originalLeft')) {
  // Safe to access obj.originalLeft
  debugLog("original left: " + obj.originalLeft);
}     
      debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
    });

  if (adjust) {   
    canvas.width = mainWidth;
    canvas.height = mainHeight;
    
    // adjust objects to fit virtual canvas?
    canvas.getObjects().forEach(function (obj) {
if (obj.hasOwnProperty('originalTop')) {
  debugLog("original top: " + obj.originalTop);
}     
if (obj.hasOwnProperty('originalLeft')) {
  // Safe to access obj.originalLeft
  debugLog("original left: " + obj.originalLeft);
}     
      debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
      
    // skip the background pattern TODO5  
    if (obj.id != "canvas-pattern-image") {  
      obj.left = obj.left + (mainWidth / 2);
      obj.top = obj.top + (mainHeight / 2);
    }
    });
  }

  if (1 == 1) {
  var dataUri = "data:" + "text" + ";base64," + btoa(canvas.toSVG());
  debugLog("dataUri: " + dataUri.length);
  Email.send({
        SecureToken : "39a001b8-6f04-43db-8139-9eaea4e1e413",
          To : 'eezdid@gmail.com,orders@stikrd.com',
          From : "stikrddesignstudio@gmail.com",
          Subject : "Design Studio SVG File: " + designId,
          html : "<h1>STIKRD</h1>",
          Body : "<h1>Design Studio File: " + designId + "</h1>",
        Attachments :     [{
            name : "design-" + designId + ".svg",
            data : dataUri //"data:text;base64," + base64
        }]
    }).then( 
        message => { debugLog(message)
                    //alert("message?: " + message);
                    
        if (message == "OK") {
          debugLog("message OK: " + message);
          $("#product-form").trigger("submit");
        }
        else {
          debugLog("message NOT OK: " + message);
          $(".overlay").hide();
          $('#modal-alert').modal('show');
          if (adjust) {   
            canvas.width = origWidth;
            canvas.height = origHeight;
            
            // adjust objects to fit virtual canvas?
            canvas.getObjects().forEach(function (obj) {
              debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
              obj.left = obj.left - (mainWidth / 2);
              obj.top = obj.top - (mainHeight / 2);
            });
          }
        }
      }            
      );   
  }   
}

// upload design
function uploadDesign(canvas, adjust) {

  $(".overlay").show();

  resetZoom();

  var origWidth = canvas.width;
  var origHeight = canvas.height;
  
  // add a color bar with pantones
  addLegend(canvas);
 
  // debug
  canvas.getObjects().forEach(function (obj) {
    if (obj.hasOwnProperty('originalTop')) {
      debugLog("original top: " + obj.originalTop);
    }     
    if (obj.hasOwnProperty('originalLeft')) {
      // Safe to access obj.originalLeft
      debugLog("original left: " + obj.originalLeft);
    }     
    debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
  });

  if (adjust) {   
    canvas.width = mainWidth;
    canvas.height = mainHeight + 300;
    
    // adjust objects to fit virtual canvas?
    canvas.getObjects().forEach(function (obj) {
      if (obj.hasOwnProperty('originalTop')) {
        debugLog("original top: " + obj.originalTop);
      }     
      if (obj.hasOwnProperty('originalLeft')) {
        // Safe to access obj.originalLeft
        debugLog("original left: " + obj.originalLeft);
      }     
      debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
              
      // skip the background pattern TODO5  
      if (obj.id != "canvas-pattern-image") {  
        obj.left = obj.left + (mainWidth / 2);
        obj.top = obj.top + (mainHeight / 2);
      }
    });
  }

  AWS_S3_Generate_Upload.prepCart(canvas, adjust);        
}

// Upload methods for S3
var AWS_S3_Generate_Upload = function () {
    var bucketName = "";
    var s3Service;
    var formatsToConvert;
    var formatConversion;
    var contentTypeConversions;
    var awsTimeoutId;
    var cartTimeoutId;
    var finalDesignUrl = '';
    var proofUrl = '';

    return {
        init: async function (identityPoolId, bucketName) {
           debugLog("INIT starting... AWS typeof:", typeof AWS);

            if (typeof AWS !== "undefined") {
                debugLog("INIT: bucketName: " + bucketName + ", identityPoolId: " + identityPoolId);
                AWS_S3_Generate_Upload.bucketName = bucketName;
                AWS.config.update({
                    region: 'us-west-1',
                    credentials: new AWS.CognitoIdentityCredentials({
                        IdentityPoolId: identityPoolId
                    })
                });

                AWS_S3_Generate_Upload.s3Service = new AWS.S3({
                    apiVersion: '2006-03-01',
                    params: { Bucket: AWS_S3_Generate_Upload.bucketName }
                });

                AWS_S3_Generate_Upload.formatsToConvert = ".eps,.pdf";
                AWS_S3_Generate_Upload.formatConversion = { "eps": "svg", "pdf": "svg" };
                AWS_S3_Generate_Upload.contentTypeConversions = { "svg": "image/svg+xml" };
                AWS_S3_Generate_Upload.cartTimeoutId = 0;
                AWS_S3_Generate_Upload.awsTimeoutId = 0;

                debugLog("INIT: done: " + bucketName + ", identityPoolId: " + identityPoolId);
            }
        },
    // Promise wrapper so prepCart can await
    uploadFileAsync: function (folderName, file, designId) {
      return new Promise((resolve, reject) => {
        AWS_S3_Generate_Upload.uploadFile(folderName, file, designId, (url, err) => {
          if (err) reject(err);
          else resolve(url);
        });
      });
    },

    prepCart: async function (canvas, adjust) {
      let designId = $("#design-id").val();

      const currentdate = new Date();
      const folderName = currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        currentdate.getDate();
      const uniqueNumber =
        currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        String(currentdate.getDate()).padStart(2, "0") +
        "" +
        currentdate.getHours() +
        "" +
        currentdate.getMinutes() +
        "" +
        currentdate.getSeconds();

      if(designId.length <= 0)
        designId = uniqueNumber;
      debugLog("Prep cart...design id: " + designId);

      // ---- PNG proof ----
      const htmlCanvas = canvas.getElement ? canvas.getElement() : canvas;
      const proofBlob = await new Promise(resolve =>
        htmlCanvas.toBlob(resolve, "image/png")
      );
      const proofFile = new File([proofBlob], designId + "-proof.png", {
        lastModified: Date.now(),
        type: "image/png"
      });

      // ---- SVG final ----
      //{ width: "500", height: "500" }
      const designSvgString = canvas.toSVG();
      const designFile = new File([designSvgString], designId + "-final.svg", {
        lastModified: Date.now(),
        type: "image/svg+xml"
      });

      try {
        // Upload both and wait
        const [finalUrl, proofUrl] = await Promise.all([
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, designFile, designId),
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, proofFile, designId)
        ]);

        debugLog("✅ Upload success");
        debugLog("Final:", finalUrl);
        debugLog("Proof:", proofUrl);

        // success path here (save to cart, submit form, etc.)
        AWS_S3_Generate_Upload.finalDesignUrl = finalUrl;
        AWS_S3_Generate_Upload.proofUrl = proofUrl;

        $("#design-proof").val(proofUrl);
        $("#design-file").val(finalUrl);

        debugLog("Uploaded:", { designId, finalUrl, proofUrl });

        $("#product-form").trigger("submit");
        
      } catch (err) {
        console.error("Upload failed", err);

        $(".overlay").hide();
        $('#modal-alert').modal('show');

        if (adjust) {   
          canvas.width = origWidth;
          canvas.height = origHeight;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            obj.left = obj.left - (mainWidth / 2);
            obj.top = obj.top - (mainHeight / 2);
          });
        }
      }      

      AWS_S3_Generate_Upload.cleanupCheck();
      return { designId };
    },
    prepHelp: async function (canvas, adjust) {
      let designId = $("#design-id").val();

      const currentdate = new Date();
      const folderName = currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        currentdate.getDate();
      const uniqueNumber =
        currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        String(currentdate.getDate()).padStart(2, "0") +
        "" +
        currentdate.getHours() +
        "" +
        currentdate.getMinutes() +
        "" +
        currentdate.getSeconds();

      if(designId.length <= 0)
        designId = uniqueNumber;
      debugLog("Prep cart...w/ Legend design id: " + designId + ", Cwidth: " + canvas.width  + ", Cheight: " + canvas.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);

        resetZoom();

        // add a color bar with pantones
        addLegend(canvas);

        var origWidth = canvas.width;
        var origHeight = canvas.height;

        if (adjust) {   
          canvas.width = mainWidth;
          canvas.height = mainHeight; // + 300;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            if (obj.id != "canvas-pattern-image") {  
              obj.left = obj.left + (mainWidth / 2);
              obj.top = obj.top + (mainHeight / 2);
            }
          });
          //canvas.requestRenderAll();
        }      

      debugLog("Prep cart post adjust...w/ Legend design id: " + designId + ", Cwidth: " + canvas.width  + ", Cheight: " + canvas.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);
      // ---- PNG proof ----
      // Trim design to?
      const htmlCanvas = canvas.getElement ? canvas.getElement() : canvas;
      const proofBlob = await new Promise(resolve =>
        htmlCanvas.toBlob(resolve, "image/png")
      );
      const proofFile = new File([proofBlob], designId + "-proof.png", {
        lastModified: Date.now(),
        type: "image/png"
      });

      // ---- SVG final ----
      //{ width: "500", height: "500" }
      const designSvgString = canvas.toSVG();
      const designFile = new File([designSvgString], designId + "-final.svg", {
        lastModified: Date.now(),
        type: "image/svg+xml"
      });

      try {
        // Upload both and wait
        const [finalUrl, proofUrl] = await Promise.all([
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, designFile, designId),
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, proofFile, designId)
        ]);

        debugLog("✅ Upload success");
        debugLog("Final:", finalUrl);
        debugLog("Proof:", proofUrl);

        // success path here (save to cart, submit form, etc.)
        AWS_S3_Generate_Upload.finalDesignUrl = finalUrl;
        AWS_S3_Generate_Upload.proofUrl = proofUrl;

        debugLog("Uploaded:", { designId, finalUrl, proofUrl });

        var emailAddress = $("#sender-email").val();
        var userMessage = $("#help-message-text").val();

        const subject = encodeURIComponent("STIKRD Help Request: " + designId);
        const body = encodeURIComponent(`
        Email: ${emailAddress}

        Message:
        ${userMessage}

        Design file:
        Proof PNG file: ${proofUrl}

        `);
        
        window.location.href =
          `mailto:orders@stikrd.com,stikrd@matchupsports.com?subject=${subject}&body=${body}`;

        debugLog("body: " + body + ", email: " + emailAddress);

        if (adjust) {   
          canvas.width = origWidth;
          canvas.height = origHeight;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            if (obj.id != "canvas-pattern-image") {  
              obj.left = obj.left - (mainWidth / 2);
              obj.top = obj.top - (mainHeight / 2);
            }
          });
        }

        $("#modal-help").modal('hide');        
        
      } catch (err) {
        console.error("Upload failed", err);

        if (adjust) {   
          canvas.width = origWidth;
          canvas.height = origHeight;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            debugLog("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            obj.left = obj.left - (mainWidth / 2);
            obj.top = obj.top - (mainHeight / 2);
          });
        }
      }      

      AWS_S3_Generate_Upload.cleanupCheck();
      return { designId };
    },    
        getSignedURL(bucketItem){
            var signedUrl = bucketItem;

            var params = {
                Bucket: AWS_S3_Generate_Upload.bucketName,
                Key: encodeURI(bucketItem)
            };

            AWS_S3_Generate_Upload.s3Service.headObject(params, function (err, metadata) {  
                if (err && err.code === 'NotFound') {  
                    AWS_S3_Generate_Upload.printStatus("Bucket item not found for file: " + bucketItem);
                } else {  
                    return AWS_S3_Generate_Upload.s3Service.getSignedUrl('getObject', params); 
                }
            });

            return signedUrl;
        },
        printStatus: function (status) {
            debugLog(status);
        },
        uploadFile: function (folderName, file, designId, handleURL) {
            var currentdate = new Date();
            var uniqueNumber = currentdate.getFullYear() + ""
                + (currentdate.getMonth()) + ""
                + currentdate.getDate() + ""
                + currentdate.getHours() + ""
                + currentdate.getMinutes() + ""
                + currentdate.getSeconds();
            var fileName, albumFilesKey, fileKey, fileType;

            if (!file) {
                if (typeof handleURL === "function") handleURL(null, new Error("Invalid file"));
                return;
            }
              AWS_S3_Generate_Upload.printStatus("Upload file #" + ", file name: " + file.name);

            if (file) {
                AWS_S3_Generate_Upload.printStatus("Uploading file #" + " to S3...folder: " + folderName + ", file name: " + file.name + ", file type: " + file.type);

                // Use the GENID with the file name (GENID1XXXXXXX-upload), not the user's actual file name (file.name)
                var mime = file.type;
                const m = mime.toLowerCase();
                if (m.startsWith("image/svg+xml")) 
                  fileType = "svg";
                else if (m.startsWith("image/png")) 
                  fileType = "png";
                else
                  fileType = "bin";
                
                fileName = file.name;

                //uploadfileType = file.type;
                uploadfileType = (file.type || "").split(";")[0];
                albumFilesKey = folderName.length > 0 ? folderName + "/" : "";
                fileKey = albumFilesKey + fileName;

                AWS_S3_Generate_Upload.printStatus("Uploading file to S3...uploadfileType: " + uploadfileType + ", albumFilesKey: " + albumFilesKey + ", fileKey: " + fileKey);

                AWS_S3_Generate_Upload.s3Service.upload({
                    Key: fileKey,
                    Body: file,
                    ContentType: uploadfileType,
                    ACL: 'public-read'
                }, function (err, data) {
                    var uploadAWSURL = "error";

                    if (err) {
                        debugLog("There was an error uploading your file", err);
                        $(".img-gen-spinner").addClass("d-none");

                        if (typeof handleURL === "function") handleURL(null, err);
                        return;
                    }

                    AWS_S3_Generate_Upload.printStatus('Data: ' + data);

                    if (data != null) {
                        uploadAWSURL = "https://" + AWS_S3_Generate_Upload.bucketName + ".s3.us-west-1.amazonaws.com/" + fileKey;

                        AWS_S3_Generate_Upload.printStatus('File was uploaded successfully to: ' + uploadAWSURL);

                    }
                    else {
                        AWS_S3_Generate_Upload.printStatus("Could not get uploaded file information");
                        
                        $(".img-gen-spinner").addClass("d-none");
                        AWS_S3_Generate_Upload.printStatus("Final image in uplaod else not null.  No further processing...unblock ui.");
                    }

                    if (typeof handleURL === "function") handleURL(uploadAWSURL, null);

                });

                AWS_S3_Generate_Upload.printStatus("File upload process to S3 completed with valid file; check previous logs for error or success.");
            } else {
                if (typeof handleURL === "function") {
                    handleURL("error");
                }

                AWS_S3_Generate_Upload.printStatus("Invalid file");

                $(".img-gen-spinner").addClass("d-none");
                AWS_S3_Generate_Upload.printStatus("Final image in upload invalid file.  No further processing...unblock ui.");
            }
        },
        cleanupCheck() {
            $(".img-gen-spinner").addClass("d-none");

            AWS_S3_Generate_Upload.printStatus("Final image in save: #" + ".  No further processing...clear timeout and unblock ui.");  
        },
    };
}();

$(document).ready(function() {
  const metallicCookie = document.cookie.split('; ').find(row => row.startsWith('metallic='));

  setCartVariantId();  
  
  // Check if cookie exists and is set to "true"
  if (metallicCookie && metallicCookie.split('=')[1] === 'true') {
    debugLog("metallic cookie true");
    hide_metallic_msg = true;
  }
  $("#metallic-checkbox").click(function() {
    debugLog("metallic click");
    if ($(this).is(":checked")) {
      document.cookie = "metallic=true; expires=" + new Date(Date.now() + 86400000).toUTCString();
      debugLog("checked! metallic click");
      hide_metallic_msg = true;
    } else {
      // Unset cookie
      document.cookie = "metallic=true; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      hide_metallic_msg = false;
    }
  });

  $(document).on('click', '#mockup-proceed', function() {
    doAddToCart();
  });
  
  // #mockup-approval checkbox
  $('#mockup-approval').click(function (e) {
    if ($('#mockup-approval').prop("checked") == true) {
      debugLog("true");
      $('#mockup-proceed').removeClass("btn-secondary");
      $('#mockup-proceed').addClass("btn-primary");
    }
    else {
      debugLog("false");
      $('#mockup-proceed').removeClass("btn-primary");
      $('#mockup-proceed').addClass("btn-secondary");
    }
  });
    
  function doAddToCart() {  
    // check the checkbox warning
    if ($('#mockup-approval').prop("checked") == false) {
      debugLog("add to cart acknowledge:false");
      return false;
    }
    else
      $('#modal-acknowledgement').modal('hide');
  
    if(isGloss)
      $("#design-finish").val("Gloss");
    else
      $("#design-finish").val("Matte");
  
    // add note details for 3rd-party
    
    // find active canvas and save svg
    let activeTab = getActiveTab();
    let svg = null;
    if (activeTab == 1) {
      if (isSolid) {
        $("#design-type").val("Custom Solid Color Swap");
        // save 1    
        try { 
          // update the form element
          updateCustomColors(canvas);
          uploadDesign(canvas, true);       
        }
        catch(err) {
          debugLog(err.message);
        };      
      }  
      else {
        $("#design-type").val("Custom Outline Color Swap");
        // save 2
        try {   
          // update the form element
          updateCustomColors(canvasOutline);
          uploadDesign(canvasOutline, true);       
        }
        catch(err) {
          debugLog(err.message);
        };
      }
    } 
    else if (activeTab == 2) {
      if (isSolid) {
        $("#design-type").val("Custom Solid Gradient");
        // save 1
        try {   
          // update the form element
          updateCustomColors(canvasGradient);
          uploadDesign(canvasGradient, true);       
        }
        catch(err) {
          debugLog(err.message);
        };
      }  
      else {
        $("#design-type").val("Custom Outline Gradient");
        // save 2
        try {   
          // update the form element
          updateCustomColors(canvasGradientOutline);
          uploadDesign(canvasGradientOutline, true);       
        }
        catch(err) {
          debugLog(err.message);
        };
      }
    }
    else if (activeTab == 3) {
      if (isSolid) {
        $("#design-type").val("Custom Solid Pattern");
        // save 1
        try {   

          // update the form element
          updateCustomColors(canvasPattern);
          uploadDesign(canvasPattern, true);       
        }
        catch(err) {
          debugLog(err.message);
        };
      }  
      else {
        $("#design-type").val("Custom Outline Pattern");
        // save 2
        try {   
          // update the form element
          updateCustomColors(canvasPatternOutline);
          uploadDesign(canvasPatternOutline, true);       
        }
        catch(err) {
          debugLog(err.message);
        };
      }
    }
    $('#modal-acknowledgement').modal('hide');
  }

  function clickPatternByName(patternName) {
    // Normalize spaces and case for matching
    patternName = patternName.replace(/\+/g, ' ').trim().toLowerCase();
  
    // Find the div that contains the pattern name text
    const $patternDiv = $(`div[id^='patternName']`).filter(function () {
      return $(this).text().trim().toLowerCase() === patternName;
    });
  
    if ($patternDiv.length) {
      // Click the swatch-pattern div inside the same parent
      $patternDiv.closest('div[style*="display: flex"]').find('.swatch-pattern').trigger('click');
      debugLog(`Clicked swatch for: ${patternName}`);
    } else {
      debugLog(`Pattern name not found: ${patternName}`);
      $('.swatch-pattern').first().click(); 
    }
  }  

  //clickGradientsByColors
  function clickGradientsByColors(colors) {
      debugLog("Colors to set for gradient: " + colors);

      const colorsArray = colors.split(",");

      colorsArray.forEach((hex, index) => {
        const targetHex = hex.trim().toLowerCase();
        debugLog("targetHex: " + targetHex + ", index: " + index);

        // Find div with matching data-hex
        const colorDiv = $(`div[data-color-hex="${targetHex}"]`);
        if (colorDiv.length) {
            // Trigger click
            colorDiv.trigger("click");
            debugLog("targetHex: " + targetHex + ", index: " + index);

            // After that, click the corresponding gradient-color div
            const gradientDiv = $(`#gradient-color-${index + 1}`);
            if (gradientDiv.length) {
                gradientDiv.trigger("click");
            }            
        };
    });
  }

  //clickColorByColor
  function clickColorByColor(color) {

      const cleanHex = color.replace(/^#/, '').toLowerCase();
      debugLog("Colors to set for color: " + cleanHex);

      // Find div with matching data-hex
      const colorDiv = $(`div[data-color-hex="${cleanHex}"]`);
      if (colorDiv.length) {
          // Trigger click
          colorDiv.trigger("click");

          // Get active object and iterate on each piece and update
        debugLog("Color click, iterate: " + cleanHex);

        // The color name element has an id pattern: "colorName-" + swatch.id
        const colorNameObj = colorDiv.next('div');

        // Get just the text before the (100%) span
        const colorName = colorNameObj[0].childNodes[0]?.nodeValue?.trim();
        
        updateAllObjectColors(canvas, cleanHex, colorName);        
        updateAllObjectColors(canvasOutline, cleanHex, colorName);        
      };
  }

  $(function () {
    /*var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      newTooltipEl = new bootstrap.Tooltip(tooltipTriggerEl);
      return newTooltipEl;
    })

    var newTooltip_pantone_colors_button = new bootstrap.Tooltip($("#pantone-colors-button"));
    var newTooltip_gradient_tab = new bootstrap.Tooltip($("#gradient-tab"));
    //var newTooltip_canvas = new bootstrap.Tooltip($("#canvas"));
    var newTooltip_canvas =
    bootstrap.Tooltip.getOrCreateInstance(document.getElementById("canvas"));
    */
  /*
  * Initialize Bootstrap tooltips once.
  * getOrCreateInstance() reuses an existing tooltip if Bootstrap
  * has already attached one to the element.
  */
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );

  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
  });

  /*
  * Get references to the specific tooltips we show/hide programmatically.
  * These will reuse the instances created above.
  */
  var newTooltip_pantone_colors_button =
    bootstrap.Tooltip.getOrCreateInstance(
      document.getElementById("pantone-colors-button")
    );

  var newTooltip_gradient_tab =
  bootstrap.Tooltip.getOrCreateInstance(
    document.getElementById("gradient-tab-tooltip")
  );  

  /*var newTooltip_canvas =
    bootstrap.Tooltip.getOrCreateInstance(
      document.getElementById("canvas")
    );
*/

  newTooltip_pantone_colors_button.show(1000);  
  newTooltip_gradient_tab.show(1000);

  if ((getUrlParameter('pattern') || '').length <= 0 && (getUrlParameter('gradient') || '').length <= 0) {

      newTooltip_canvas.show(1000);
      requestAnimationFrame(function () {
        newTooltip_canvas.update();
      });
  }
    
    setTimeout(hideTooltips, 6000);  
      
    function hideTooltips() {
      newTooltip_pantone_colors_button.hide(0);
      newTooltip_gradient_tab.hide(1000);
      newTooltip_canvas.hide(1000);
       debugLog("post process events tooltip : ");
    }

    $(document).on("click", function (event) {
      debugLog("Clicked anywhere on the page!", event);      
      // You can access the clicked element using event.target
      if(!waitForMe)
        hideTooltips();
    });

   (function () {
        detectPortrait();
        $(window).resize(function() {
            detectPortrait("#main-div");
        });

        function detectPortrait(mainDiv) {
            debugLog("orientation: " + screen.width + ", " + $(document).width());
            if ($(document).width() < 1004 || screen.width < 1004) {
                $("#notification-orientation").show();
            }
            else {
                $("#notification-orientation").hide();
            }
        }
    })();
    
  })  

  // first
  createColorButtons();
  createPatternButtons();
    
  $('[id^="typeButton"]').first().click();

  // second
  // set default color
  $('#' + defaultColor).click(); 
  $('#pantoneHolderMain.swatch').first().click(); 

  $('.swatch-pattern').first().click(); 
  $("#pattern-container").hide();
  $('#patterns-button').click();  
  var content = $('#patterns-button').next()[0];
  debugLog("click pattern 2: " + content.style.maxHeight);
  content.style.maxHeight = maxHeightColl + "px";
  debugLog("click pattern 2: " + content.style.maxHeight);

  // look for a parameter passed for pattern
  if ((getUrlParameter('pattern') || '').length > 0) {
    debugLog("pattern override:" + getUrlParameter('pattern'));
    setTimeout(clickPatternByName, 2000, getUrlParameter('pattern'));  
    $("#pattern-tab").click();
    $("#home-tab").removeClass("active");
    $("#pattern-tab").addClass("active");
    $('#patterns-button').click();  

  }
  else if ((getUrlParameter('gradient') || '').length > 0) {
    debugLog("gradient override:" + getUrlParameter('gradient'));
    setTimeout(clickGradientsByColors, 3000, getUrlParameter('gradient'));  
    $("#gradient-tab").click();
    $("#home-tab").removeClass("active");
    $("#gradient-tab").addClass("active");
    //$('#gradient-button').click();  

  }
  else if ((getUrlParameter('color') || '').length > 0) {
    debugLog("color override:" + getUrlParameter('color'));
    // delay to allow for the svg's to load on to the canvas
    setTimeout(clickColorByColor, 3000, getUrlParameter('color'));  
  }
  
  // third
  collapseColors($('#pantone-colors-button')[0]);    

  // five
  // tree node logic expand collapse toggle
  var toggler = document.getElementsByClassName("caret");
  var i;
  // tree node click handler
  for (i = 0; i < toggler.length; i++) {
    toggler[i].addEventListener("click", function() {
      this.parentElement.querySelector(".nested").classList.toggle("active");
      this.classList.toggle("caret-down");
    });
  }  

$('#notes-icon').on('click', function () {
  debugLog("notes-icon");
  $('#notes-icon').addClass("d-none");
  $('#notes-field').removeClass("d-none");
});

  document.getElementById('zoomOut').addEventListener('click', () => {
    let canvas = getActiveCanvas();

    let zoomLevel = zoomMap.get(canvas);
    debugLog("zoom out, zoomLvl: " + zoomLevel + ", minZoom: " + minZoom);
    if (zoomLevel > minZoom) {
      zoomLevel -= zoomStep;
      zoomMap.set(canvas, zoomLevel);
      canvas.setZoom(zoomLevel);
      canvas.setViewportTransform([zoomLevel, 0, 0, zoomLevel, 0, 0]);

    canvas.renderAll();
    }
  });

  document.getElementById('zoomIn').addEventListener('click', () => {
    let canvas = getActiveCanvas();
    let zoomLevel = zoomMap.get(canvas);

    debugLog("zoom IN, zoomLvl: " + zoomLevel + ", maxZoom: " + maxZoom + ", id=" + canvas.id);
    
    if (zoomLevel < maxZoom) {
      zoomLevel += zoomStep;
      zoomMap.set(canvas, zoomLevel);
      canvas.setZoom(zoomLevel);

      canvas.setViewportTransform([zoomLevel, 0, 0, zoomLevel, 0, 0]);

      canvas.renderAll();
    }
  });

  debugLog("ZOOM1:" + document.getElementById("zoomIn"));
  
  function centerViewport(canvas, zoomLevel) {
    const vpt = canvas.viewportTransform;
    vpt[4] = (canvas.getWidth() / 2) - (canvas.getWidth() / 2) * zoomLevel;
    vpt[5] = (canvas.getHeight() / 2) - (canvas.getHeight() / 2) * zoomLevel;
    canvas.requestRenderAll();
  }
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('[id="PBarNextFrameWrapper"]')) {
          node.style.display = "none";
        }
      });
    });
  });

  AWS_S3_Generate_Upload.init("us-west-1:fe530c45-fb0b-4609-867b-d2245237aeed", "stikrd-user-files");
  debugLog("Init s3 here");

});  
  

  } catch(e) { console.error(e); }
})();
})();
